<template>
	<div class=" flexCol alit">
		<!-- <div class="top-title">重庆火锅产业大脑</div> -->
		<div class="top-count flex justc">
			<div class="flex alit">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A6%96%E9%A1%B5/%E4%BA%A7%E4%B8%9A%E6%80%BB%E5%80%BC%402x%20%281%29.png"
					style="width:60px;height: 60px;margin-right: 10px;" alt="" />
				<div class="" style="margin-left: -10px;">

					<div class="flex top-count-num">
						<countTo ref="countTo1" :startVal='0' :endVal='3600' separator="" :duration='3000' class="">
						</countTo>
					</div>
					<div class="top-count-title">产业总值 <a>(亿)</a></div>
				</div>
			</div>
			<div class="flex alit" style="margin: 0 10px;">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A6%96%E9%A1%B5/%E5%85%A8%E7%90%83%E5%88%86%E5%B8%83%402x%20%281%29.png"
					style="width: 60px;height: 60px;margin-right: 10px;" alt="" />
				<div class="" style="margin-left: -10px;">
					<div class="flex top-count-num">
						<countTo ref="countTo1" :startVal='0' :endVal='200' separator="" :duration='3000' class="">
						</countTo>
					</div>
					<div class="top-count-title">全球城市 (<a>个</a>)</div>
				</div>
			</div>
			<div class="flex alit">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A6%96%E9%A1%B5/%E5%85%A8%E5%9B%BD%E5%88%86%E5%B8%83%402x%20%281%29.png"
					style="width: 60px;height: 60px;margin-right: 10px;" alt="" />
				<div class="" style="margin-left: -10px;">

					<div class="flex top-count-num">
						<countTo ref="countTo1" :startVal='0' :endVal='50' separator="" :duration='3000' class="">
						</countTo>+
					</div>
					<div class="top-count-title">全国门店(<a>万</a>)</div>
				</div>
			</div>
			<div class="flex alit" style="margin: 0 10px;">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A6%96%E9%A1%B5/%E9%87%8D%E5%BA%86%E4%BC%81%E4%B8%9A%402x%20%281%29.png"
					style="width: 60px;height: 60px;margin-right: 10px;" alt="" />
				<div class="" style="margin-left: -10px;">
					<div class="flex top-count-num">
						<countTo ref="countTo1" :startVal='0' :endVal='20' separator="" :duration='3000' class="">
						</countTo>+
					</div>
					<div class="top-count-title">重庆火锅(<a>万</a>)</div>
				</div>
			</div>
			<div class="flex alit">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A6%96%E9%A1%B5/%E6%9C%AC%E5%B8%82%E9%97%A8%E5%BA%97%402x%20%281%29.png"
					style="width: 60px;height: 60px;margin-right: 10px;" alt="" />
				<div class="" style="margin-left: -10px;">
					<div class="flex top-count-num">
						<countTo ref="countTo1" :startVal='0' :endVal='3.9' separator="" :duration='3000' :decimals="1"
							class=""></countTo>
					</div>
					<div class="top-count-title">本市门店(<a>万</a>)</div>
				</div>
			</div>
		</div>

		<div class="top-count2 flex justc">
			<div class="flex alit">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A6%96%E9%A1%B5/%E5%B0%B1%E4%B8%9A%E4%BA%BA%E6%95%B0%402x%20%281%29.png"
					style="width: 60px;height: 60px;margin-right: 10px;" alt="" />
				<div class="" style="margin-left: -10px;">
					<div class="flex top-count-num">
						<countTo ref="countTo1" :startVal='0' :endVal='112' separator="" :duration='3000' class="">
						</countTo>
					</div>
					<div class="top-count-title">就业人数(<a>万</a>)</div>
				</div>
			</div>
			<div class="flex alit" style="margin: 0 10px;" @click="dialogVisible2 = true">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A6%96%E9%A1%B5/%E6%9C%8D%E5%8A%A1%E4%BC%81%E4%B8%9A%402x%20%281%29.png"
					style="width: 60px;height: 60px;margin-right: 10px;" alt="" />
				<div class="" style="margin-left: -10px;">
					<div class="flex top-count-num">
						<countTo ref="countTo1" :startVal='0' :endVal='1750' separator="" :duration='3000' class="">
						</countTo>
					</div>
					<div class="top-count-title">会员企业(<a>家</a>)</div>
				</div>
			</div>
			<div class="flex alit" @click="dialogVisible = true">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A6%96%E9%A1%B5/%E4%BA%A4%E6%98%93%E9%87%91%E9%A2%9D%402x%20%281%29.png"
					style="width: 60px;height: 60px;margin-right: 10px;" alt="" />
				<div class="" style="margin-left: -10px;">
					<div class="flex top-count-num">
						<countTo ref="countTo1" :startVal='0' :endVal='10000' separator="" :duration='3000' class="">
						</countTo>+
					</div>
					<div class="top-count-title">交易金额(<a>万</a>)</div>
				</div>
			</div>
			<div class="flex alit" style="margin: 0 10px;">
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A6%96%E9%A1%B5/%E8%9E%8D%E8%B5%84%E9%87%91%E9%A2%9D%402x%20%281%29.png"
					style="width: 60px;height: 60px;margin-right: 10px;" alt="" />
				<div class="" style="margin-left: -10px;">
					<div class="flex top-count-num">
						<countTo ref="countTo1" :startVal='0' :endVal='2400' separator="" :duration='3000' class="">
						</countTo>
					</div>
					<div class="top-count-title">融资金额(<a>万</a>)</div>
				</div>
			</div>
			<div class="flex alit" >
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A6%96%E9%A1%B5/%E9%A3%9F%E5%AE%89%E6%BA%AF%E6%BA%90%402x%20%281%29.png"
					style="width: 60px;height: 60px;margin-right: 10px;" alt="" @click="dialogOpenSasy = true" />
				<div class="" style="margin-left: -10px;cursor: pointer;" @click="openSyMechart">
					<div class="flex top-count-num" >
						<countTo ref="countTo1" :startVal='0' :endVal='150' separator="" :duration='3000' class="">
						</countTo>
					</div>
					<div class="top-count-title">食安溯源(<a>万</a>)</div>
				</div>
			</div>
		</div>

		<div class="centerbg flexCol alit justc" style="height: 100vh;">
			<!-- <img :src="'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E8%83%8C%E6%99%AF.png?v='+nowTime"
				alt="" style="width: 110vw;height: 110vh;position: absolute;margin-top: -20vh;" /> -->
			<center-map style="width: 100vw;height: 100vh;position: absolute;z-index: 2;margin-top:0%;"
				:scanal="110"></center-map>
		</div>

		<div class="left flexCol">
			<div class="title">
				<div class="">政府侧</div>
			</div>
			<div class="info-style flexCol justb" style="padding-bottom: 5px;">
				<div class="flex justb">
					<div class="flexCol alit justc" :class="tabbarIndex1 == 1 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex1 = 1,changeCyyx(1)">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%BA%A7%E4%B8%9A%E8%BF%90%E8%A1%8C%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex1 == 1" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%BA%A7%E4%B8%9A%E8%BF%90%E8%A1%8C.png"
							alt="" v-else />
						<div class="">产业运行</div>
					</div>
					<div class="flexCol alit justc" :class="tabbarIndex1 == 2 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex1 = 2,changeZcfw(1)">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E6%94%BF%E7%AD%96%E6%9C%8D%E5%8A%A1%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex1 == 2" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E6%94%BF%E7%AD%96%E6%9C%8D%E5%8A%A1.png"
							alt="" v-else />
						<div class="">政策服务</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex1 == 3 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex1 = 3,changeCyzs(1)">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%BA%A7%E4%B8%9A%E6%8B%9B%E5%95%86%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex1 == 3" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%BA%A7%E4%B8%9A%E6%8B%9B%E5%95%86.png"
							alt="" v-else />
						<div class="">产业招商</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex1 == 4 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex1 = 4,tabbarChildIndex1 = 1">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E9%A2%84%E8%AD%A6%E5%86%B3%E7%AD%96%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex1 == 4" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E9%A2%84%E8%AD%A6%E5%86%B3%E7%AD%96.png"
							alt="" v-else />
						<div class="">预警决策</div>
					</div>
				</div>
				<div class="flex justb" style="margin: 10px 0;" v-if="tabbarIndex1 == 1">
					<div :class="tabbarChildIndex1 == 1 ? 'check2' : 'check2-defalut'" @click="changeCyyx(1)">产业总产值
					</div>
					<div :class="tabbarChildIndex1 == 2 ? 'check2' : 'check2-defalut'" @click="changeCyyx(2)">增加值增速
					</div>
					<div :class="tabbarChildIndex1 == 3 ? 'check2' : 'check2-defalut'" @click="changeCyyx(3)">出口额/增速
					</div>
					<div :class="tabbarChildIndex1 == 4 ? 'check2' : 'check2-defalut'" @click="changeCyyx(4)">进口额/增速
					</div>
					<div :class="tabbarChildIndex1 == 5 ? 'check2' : 'check2-defalut'" @click="changeCyyx(5)">利润总额</div>
				</div>
				<div class="flex justb" style="margin: 10px 0;" v-if="tabbarIndex1 == 2">
					<!-- <div :class="tabbarChildIndex1 == 1 ? 'check2' : 'check2-defalut'" @click="changeZcfw(1)">
					</div> -->
					<div class="flex alit" style="cursor: pointer;" @click="changeZcfw(1)">
						<img class="gf-images"
							src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%94%BF%E7%AD%96%E6%9C%8D%E5%8A%A1/%E4%BA%A7%E4%B8%9A%E6%94%BF%E7%AD%96%402x.png"
							alt="" />
						<div class="">
							<div class="" :class="tabbarChildIndex1 == 1 ? 'gf-num' : 'gf-num-defalut'">
								<div class="">{{ policyCounts[1] }}</div>
							</div>
							<div class="" :class="tabbarChildIndex1 == 1 ? 'gf-num-title' : 'gf-num-title-defalut'">
								产业政策</div>
						</div>
					</div>
					<div class="flex alit" @click="changeZcfw(2)" style="margin: 0 10px;cursor: pointer;">
						<img class="gf-images"
							src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%94%BF%E7%AD%96%E6%9C%8D%E5%8A%A1/%E9%87%91%E8%9E%8D%E6%94%BF%E7%AD%96%402x.png"
							alt="" />
						<div class="">
							<div class="" :class="tabbarChildIndex1 == 2 ? 'gf-num' : 'gf-num-defalut'">
								<div class="">{{ policyCounts[2] }}</div>
							</div>
							<div class="" :class="tabbarChildIndex1 == 2 ? 'gf-num-title' : 'gf-num-title-defalut'">
								金融政策</div>
						</div>
					</div>

					<div class="flex alit" style="cursor: pointer;" @click="changeZcfw(3)">
						<img class="gf-images"
							src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%94%BF%E7%AD%96%E6%9C%8D%E5%8A%A1/%E6%8C%87%E5%AF%BC%E6%84%8F%E8%A7%81%402x.png"
							alt="" />
						<div class="">
							<div class="" :class="tabbarChildIndex1 == 3 ? 'gf-num' : 'gf-num-defalut'">
								<div class="">{{ policyCounts[3] }}</div>
							</div>
							<div class="" :class="tabbarChildIndex1 == 3 ? 'gf-num-title' : 'gf-num-title-defalut'">
								指导意见</div>
						</div>
					</div>

					<!-- <div :class="tabbarChildIndex1 == 2 ? 'check2' : 'check2-defalut'" @click="changeZcfw(2)"
						style="margin: 0 10px;">金融政策<a>(7条)</a>
					</div>
					<div :class="tabbarChildIndex1 == 3 ? 'check2' : 'check2-defalut'" @click="changeZcfw(3)">
						指导意见<a>(5条)</a>
					</div> -->
				</div>
				<div class="flex" style="margin: 10px 0 0 0;" v-if="tabbarIndex1 == 3">
					<div :class="tabbarChildIndex1 == 1 ? 'check2' : 'check2-defalut'" @click="changeCyzs(1)">
						供应链<a>({{ investCounts[1] }}条)</a>
					</div>
					<div :class="tabbarChildIndex1 == 2 ? 'check2' : 'check2-defalut'" @click="changeCyzs(2)"
						style="margin: 0 10px;">加工企业<a>({{ investCounts[2] }}条)</a>
					</div>
					<div :class="tabbarChildIndex1 == 3 ? 'check2' : 'check2-defalut'" @click="changeCyzs(3)"
						style="margin: 0 10px 0 0;">物流<a>({{ investCounts[3] }}条)</a>
					</div>
					<div :class="tabbarChildIndex1 == 4 ? 'check2' : 'check2-defalut'" @click="changeCyzs(4)">
						品牌加盟<a>({{ investCounts[4] }}条)</a>
					</div>
				</div>
				<div class="left-top operation-overview" v-if="tabbarIndex1 == 1">
					<div v-if="operationLoading" class="operation-state" role="status">正在加载产业运行数据…</div>
					<div v-else-if="operationError" class="operation-state" role="alert">
						<span>{{ operationError }}</span>
						<button type="button" class="operation-retry" @click="loadIndustryOperation">重新加载</button>
					</div>
					<template v-else-if="operationScenario">
						<div class="operation-overview-heading">{{ operationData.year }}年{{ operationData.startMonth }}—{{ operationData.endMonth }}月</div>
						<leftTop class="operation-overview-chart" :chart-data="operationScenario" compact></leftTop>
						<!-- <div class="operation-source" :title="operationData.sourceNote">{{ operationData.demo ? '沿用原页面示例数据 · 未提供月份留空' : '产业运行月度数据' }}</div> -->
					</template>
					<div v-else class="operation-state" role="status">
						<span>暂无产业运行数据</span>
						<button type="button" class="operation-retry" @click="loadIndustryOperation">重新加载</button>
					</div>
				</div>

				<div class="fw-content" v-if="tabbarIndex1 == 2 || tabbarIndex1 == 3">
					<!-- 政策服务：真实政策列表，仅展示政策名称，点击查看 -->
					<div class="" v-if="tabbarIndex1 == 2">
						<div class="" v-show="policyLoading" style="padding: 10px 5px; color: #8AD4FF;">加载中…</div>
						<div class="" v-show="!policyLoading && !policyList.length" style="padding: 10px 5px; color: #8AD4FF;">暂无政策数据</div>
						<div class="list list-style flex alit" v-for="(item,index) in policyList" :key="item.id" style="cursor: pointer;" @click="openPolicyDetail(item)">
							<div class="" style="width: 10px;">
								<div class="zc-shuxian"></div>
							</div>
							<div class="zc-num">{{index + 1}}</div>
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%94%BF%E7%AD%96%E6%9C%8D%E5%8A%A1/%E6%98%9F%402x.png" alt="" />
							<div class="policy-name" :title="item.name" style="color: #8AD4FF;">{{item.name}}</div>
						</div>
					</div>
					<!-- 产业招商：真实招商列表，仅展示项目名称，点击查看 -->
					<div class="" v-else-if="tabbarIndex1 == 3">
						<div class="" v-show="investLoading" style="padding: 10px 5px; color: #8AD4FF;">加载中…</div>
						<div class="" v-show="!investLoading && !investList.length" style="padding: 10px 5px; color: #8AD4FF;">暂无招商数据</div>
						<div class="list list-style flex alit" v-for="(item,index) in investList" :key="item.id" style="cursor: pointer;" @click="openInvestDetail(item)">
							<div class="" style="width: 10px;">
								<div class="zc-shuxian"></div>
							</div>
							<div class="zc-num">{{index + 1}}</div>
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%94%BF%E7%AD%96%E6%9C%8D%E5%8A%A1/%E6%98%9F%402x.png" alt="" />
							<div class="policy-name" :title="item.name" style="color: #8AD4FF;">{{item.name}}</div>
						</div>
					</div>
				</div>
				<div class="" v-if="tabbarIndex1 == 4">
					<yjjc></yjjc>
				</div>
				<div class="flex justb alit">
					<div class="data-time">更新时间：{{yesterDay}}</div>
				</div>
			</div>

			<div class="title" style="margin: 20px 0 5px 0;">
				<div class="">产业侧</div>
			</div>
			<div class="info-style" style="padding-bottom: 0 !important;">
				<div class="flex justb">
					<div class="flexCol alit justc" :class="tabbarIndex2 == 1 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex2 = 1,changeTp(1)">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%BA%A7%E4%B8%9A%E5%9B%BE%E8%B0%B1%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex2 == 1" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%BA%A7%E4%B8%9A%E5%9B%BE%E8%B0%B1.png"
							alt="" v-else />
						<div class="">产业图谱</div>
					</div>
					<div class="flexCol alit justc" :class="tabbarIndex2 == 2 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex2 = 2,changeXmjs(1)">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E9%A1%B9%E7%9B%AE%E5%BB%BA%E8%AE%BE%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex2 == 2" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E9%A1%B9%E7%9B%AE%E5%BB%BA%E8%AE%BE.png"
							alt="" v-else />
						<div class="">项目建设</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex2 == 3 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex2 = 3,bzgfClick(1)">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E6%A0%87%E5%87%86%E8%A7%84%E8%8C%83%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex2 == 3" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E6%A0%87%E5%87%86%E8%A7%84%E8%8C%83.png"
							alt="" v-else />
						<div class="">标准规范</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex2 == 4 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex2 = 4">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E5%B1%95%E4%BC%9A%E6%B4%BB%E5%8A%A8%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex2 == 4" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E5%B1%95%E4%BC%9A%E6%B4%BB%E5%8A%A8.png"
							alt="" v-else />
						<div class="">展会活动</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex2 == 5 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex2 = 5">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E5%8D%8F%E4%BC%9A%E6%9C%8D%E5%8A%A1%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex2 == 5" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E5%8D%8F%E4%BC%9A%E6%9C%8D%E5%8A%A1.png"
							alt="" v-else />
						<div class="">协会服务</div>
					</div>
				</div>
				<div class="flex" style="margin: 5px 0;" v-if="tabbarIndex2 == 1">
					<div :class="tabbarChildIndex2 == 1 ? 'check3' : 'check3-defalut'" @click="changeTp(1)">食材基地</div>
					<div :class="tabbarChildIndex2 == 2 ? 'check3' : 'check3-defalut'" @click="changeTp(2)"
						style="margin: 0 10px;">生产加工</div>
					<div :class="tabbarChildIndex2 == 3 ? 'check3' : 'check3-defalut'" @click="changeTp(3)">火锅企业</div>
				</div>
				<!-- <div class="flex" style="margin: 5px 0;" v-if="tabbarIndex2 == 2">
					<div :class="tabbarChildIndex2 == 1 ? 'check3' : 'check3-defalut'" @click="changeXmjs(1)">火锅文旅</div>
					<div :class="tabbarChildIndex2 == 2 ? 'check3' : 'check3-defalut'" @click="changeXmjs(2)"
						style="margin: 0 10px;">食材基地建设</div>
					<div :class="tabbarChildIndex2 == 3 ? 'check3' : 'check3-defalut'" @click="changeXmjs(3)"
						style="margin-right: 10px;">食材加工厂建设</div>
					<div :class="tabbarChildIndex2 == 4 ? 'check3' : 'check3-defalut'" @click="changeXmjs(4)">物流体系建设
					</div>
				</div> -->
				<div class="flex alit" v-if="tabbarIndex2 == 1">
					<div style="margin-right: 5px;">
						<div class="tp-left flexCol justc">
							<div class="tp-zcz">总产值</div>
							<div class="tp-zcz-num">{{tpScList.zcz}}</div>
						</div>
						<div class="tp-left flexCol justc" style="margin-top: 50px;">
							<div class="tp-zcz">企业总数</div>
							<div class="tp-zcz-num2">{{tpScList.qyCount}}</div>
						</div>
					</div>
					<div class="flexCol">
						<div class="flex alit justb tp-list" v-for="item in tpScList.list">
							<div class="flex alit tp-list-title">
								<div class="tp-color" :style="{background:item.color}"></div>
								{{item.title}}
							</div>
							<div class="">
								<div class="tp-list-count">总产值: <a style="color: #DCA75A;">{{item.count}}</a> </div>
								<div class="tp-list-count" style="margin-top: 5px;">企业总数:<a
										style="color: #0AA7FF;">{{item.comCount}}</a></div>
							</div>
							<img class="tp-list-jiantou"
								src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BA%A7%E4%B8%9A/%E5%9B%BE%E8%B0%B1%E5%8F%B3%E7%AE%AD%E5%A4%B4%402x.png"
								alt="" />
						</div>
					</div>
				</div>
				<!-- 	<div class="fw-content minHeight" v-if="xmjsText.length > 0 && tabbarIndex2 == 2 ">
					<div class="list flex alit" v-for="item in xmjsText">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BA%A7%E4%B8%9A/cont%402x.png"
							alt="" />
						<div class="" style="color: #8AD4FF;">{{item}}</div>
					</div>
				</div> -->

				<div class=" bzgf flexCol alit" style="" v-if="tabbarIndex2 == 2">
					<div class="flex" style="margin: 8px 0;">
						<div class="" style="cursor: pointer;width: 3.5vw;">
							<div class="" @click="changeXmjs(1)">
								<div class="" :class="tabbarChildIndex2 == 1 ? 'gf-num' : 'gf-num-defalut'">
									<div class="">2</div>
								</div>
								<div class="" :class="tabbarChildIndex2 == 1 ? 'gf-num-title' : 'gf-num-title-defalut'">
									火锅文旅</div>
							</div>
							<div class="" style="margin-top: 15px;" @click="changeXmjs(2)">
								<div :class="tabbarChildIndex2 == 2 ? 'gf-num' : 'gf-num-defalut'">
									<div class="">12</div>
								</div>
								<div :class="tabbarChildIndex2 == 2 ? 'gf-num-title' : 'gf-num-title-defalut'">食材基地
								</div>
							</div>
						</div>

						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BA%A7%E4%B8%9A/%E9%A1%B9%E7%9B%AE%E5%BB%BA%E8%AE%BE%E4%B8%AD%E9%97%B4%402x.png"
							class="gf-image" alt="" @click="luyu = true" />
						<div class="" style="cursor: pointer;width: 3.5vw;">
							<div class="" @click="changeXmjs(3)">
								<div :class="tabbarChildIndex2 == 3 ? 'gf-num' : 'gf-num-defalut'">
									<div class="">32</div>
								</div>
								<div :class="tabbarChildIndex2 == 3 ? 'gf-num-title' : 'gf-num-title-defalut'">食材加工厂
								</div>
							</div>
							<div class="" style="margin-top: 15px;" @click="changeXmjs(4)">
								<div :class="tabbarChildIndex2 == 4 ? 'gf-num' : 'gf-num-defalut'">
									<div class="">5</div>
								</div>
								<div :class="tabbarChildIndex2 == 4 ? 'gf-num-title' : 'gf-num-title-defalut'">物流体系
								</div>
							</div>
						</div>
					</div>
					<div class="bzgf-list">
						<div class="gflist flex alit" v-for="item in xmjsText">
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BA%A7%E4%B8%9A/cont%402x.png"
								alt="" />
							<div class="" style="color: #8AD4FF;">{{item}}</div>
						</div>
					</div>
				</div>

				<div class=" bzgf flexCol alit" style="" v-if="tabbarIndex2 == 3">
					<div class="flex alit justb" style="margin: 8px 0;width: 90%;">
						<div class="" style="cursor: pointer;width: 3.5vw;">
							<div class="" @click="bzgfClick(1)">
								<div :class="tabbarChildIndex2 == 1 ? 'gf-num' : 'gf-num-defalut'">
									<div class="">{{ standardCounts[1] }}</div>
								</div>
								<div :class="tabbarChildIndex2 == 1 ? 'gf-num-title' : 'gf-num-title-defalut'">国家标准
								</div>
							</div>
							<div class="" style="margin-top: 15px;" @click="bzgfClick(3)">
								<div :class="tabbarChildIndex2 == 3 ? 'gf-num' : 'gf-num-defalut'">
									<div class="">{{ standardCounts[3] }}</div>
								</div>
								<div :class="tabbarChildIndex2 == 3 ? 'gf-num-title' : 'gf-num-title-defalut'">行业标准
								</div>
							</div>
						</div>

						<div class="flexCol alit" style="margin: 0 24px;">
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%BB%BF%E8%89%B2%E5%8F%91%E5%B1%95/%E6%A0%87%E5%87%86%E8%A7%84%E8%8C%83%402x.png"
								class="gf-image" style="width: 60px; height: 60px; margin: 0;" alt="" />
							<div class="" style="cursor: pointer;margin-top: 4px;" @click="bzgfClick(5)">
								<div :class="tabbarChildIndex2 == 5 ? 'gf-num' : 'gf-num-defalut'">
									<div class="">{{ standardCounts[5] }}</div>
								</div>
								<div :class="tabbarChildIndex2 == 5 ? 'gf-num-title' : 'gf-num-title-defalut'">技术标准
								</div>
							</div>
						</div>
						<div class="" style="cursor: pointer;width: 3.5vw;">
							<div class="" @click="bzgfClick(2)">
								<div :class="tabbarChildIndex2 == 2 ? 'gf-num' : 'gf-num-defalut'">
									<div class="">{{ standardCounts[2] }}</div>
								</div>
								<div :class="tabbarChildIndex2 == 2 ? 'gf-num-title' : 'gf-num-title-defalut'">食材标准
								</div>
							</div>
							<div class="" style="margin-top: 15px;" @click="bzgfClick(4)">
								<div :class="tabbarChildIndex2 == 4 ? 'gf-num' : 'gf-num-defalut'">
									<div class="">{{ standardCounts[4] }}</div>
								</div>
								<div :class="tabbarChildIndex2 == 4 ? 'gf-num-title' : 'gf-num-title-defalut'">准入标准
								</div>
							</div>
						</div>
					</div>
					<div class="bzgf-list" style="height: 150px; width: 100%;">
						<div class="" v-show="standardLoading" style="padding: 10px 5px; color: #8AD4FF;">加载中…</div>
						<div class="" v-show="!standardLoading && !standardList.length" style="padding: 10px 5px; color: #8AD4FF;">暂无标准数据</div>
						<div class="gflist flex alit" v-for="(item,index) in standardList" :key="item.id" style="cursor: pointer;" @click="openStandardDetail(item)">
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BA%A7%E4%B8%9A/cont%402x.png"
								alt="" />
							<div class="policy-name" :title="item.name" style="color: #8AD4FF;">{{item.name}}</div>
						</div>
					</div>
				</div>

				<bottom-center ref="bottomCenter" style="width: 100%;height: 32vh;"
					v-if="tabbarIndex2 == 4"></bottom-center>
				<div class="flexCol alit justc" style="width: 100%;height: 80%;">
					<div class="flex exhibit-btn-row" style="margin-bottom: 10px;" v-if="tabbarIndex2 == 5">
						<div class="exhibit-btn" @click="openExhibitorPdf('2025')">2025年展商名录</div>
						<div class="exhibit-btn" @click="openExhibitorPdf('2026')">2026年展商名录</div>
					</div>
					<bottom-right ref="bottomRight" style="width: 100%;height: 26vh;"
						v-if="tabbarIndex2 == 5"></bottom-right>
				</div>
			</div>
		</div>
		<div class="right flexCol">
			<div class="title" style="margin: 0px 0 5px 0;">
				<div class="">社会侧</div>
			</div>
			<div class="info-style flexCol justb" style="padding-bottom: 0 !important;">
				<div class="flex justb">
					<div class="flexCol alit justc" :class="tabbarIndex3 == 1 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex3 = 1">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%BA%BA%E6%89%8D%E6%9C%8D%E5%8A%A1%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex3 == 1" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%BA%BA%E6%89%8D%E6%9C%8D%E5%8A%A1.png"
							alt="" v-else />
						<div class="">人才服务</div>
					</div>
					<div class="flexCol alit justc" :class="tabbarIndex3 == 2 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex3 = 2">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E9%87%91%E8%9E%8D%E6%9C%8D%E5%8A%A1%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex3 == 2" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E9%87%91%E8%9E%8D%E6%9C%8D%E5%8A%A1.png"
							alt="" v-else />
						<div class="">金融服务</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex3 == 3 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex3 = 3">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E7%A7%91%E5%88%9B%E6%9C%8D%E5%8A%A1%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex3 == 3" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E7%A7%91%E5%88%9B%E6%9C%8D%E5%8A%A1.png"
							alt="" v-else />
						<div class="">科创服务</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex3 == 4 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex3 = 4">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%BF%A1%E7%94%A8%2B%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex3 == 4" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%BF%A1%E7%94%A8%2B.png"
							alt="" v-else />
						<div class="">信用+</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex3 == 5 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex3 = 5">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E9%A3%9F%E5%93%81%E5%AE%89%E5%85%A8%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex3 == 5" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E9%A3%9F%E5%93%81%E5%AE%89%E5%85%A8.png"
							alt="" v-else />
						<div class="">食品安全</div>
					</div>
				</div>

				<div class="flex justc rc-bg" v-if="tabbarIndex3 == 1">
					<div class="flexCol alit">
						<div class="flexCol alit" style="margin-top: 30px;">
							<div class="rc-num">1000万</div>
							<div class="rc-title">火锅人才总量</div>
						</div>
						<homeRight1 style="height: 120px;width: 120px;margin-top: 30px;margin-bottom: 20px;">
						</homeRight1>
					</div>
					<div class="flexCol alit" style="margin: 0 5%;">
						<div class="flexCol alit" style="margin-top: 30px;">
							<div class="rc-num">6.8%/年</div>
							<div class="rc-title">人才增速</div>
						</div>
						<homeRight2 style="height: 120px;width: 120px;margin-top: 30px;margin-bottom: 20px;">
						</homeRight2>
					</div>
					<div class="flexCol alit">
						<div class="flexCol alit" style="margin-top: 30px;">
							<div class="rc-num">32%</div>
							<div class="rc-title"> 高技能人才占比</div>
						</div>
						<homeRight3 style="height: 120px;width: 120px;margin-top: 30px;margin-bottom: 20px;">
						</homeRight3>
					</div>
				</div>
				<div class="flex alit rc-news" v-if="tabbarIndex3 == 1">
					<div class="yuan"></div>
					从服务员到店长:18个月逆袭，薪资增长6000元.
				</div>
				<div class="" v-if="tabbarIndex3 == 2">
					<jrfw></jrfw>
				</div>
				<div class="" v-if="tabbarIndex3 == 4">
					<xy></xy>
				</div>
				<food-safety-panel v-if="tabbarIndex3 == 5"></food-safety-panel>
				<div class="" v-if="tabbarIndex3 == 3">
					<div class="flex justc fwcx-top">
						<div class="flexCol alit justc kc-bg" @click="changeIndex3(1)">
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%A7%91%E5%88%9B%E6%9C%8D%E5%8A%A1/%E6%9C%8D%E5%8A%A1%E5%88%9B%E6%96%B0%402x%20%281%29.png"
								alt="" />
							<div class="fwcx-title">服务创新</div>
						</div>
						<div class="flexCol alit justc kc-bg" style="margin:0 30px;" @click="changeIndex3(2)">
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%A7%91%E5%88%9B%E6%9C%8D%E5%8A%A1/%E6%8A%80%E6%9C%AF%E5%88%9B%E6%96%B0%402x%20%281%29.png"
								alt="" />
							<div class="fwcx-title">技术创新</div>
						</div>
						<div class="flexCol alit justc kc-bg" @click="changeIndex3(3)">
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%A7%91%E5%88%9B%E6%9C%8D%E5%8A%A1/%E4%BA%BA%E6%89%8D%E5%88%9B%E6%96%B0%402x%20%281%29.png"
								alt="" />
							<div class="fwcx-title">人才创新</div>
						</div>
						<div class="flexCol alit justc kc-bg" style="margin-left: 30px;" @click="changeIndex3(4)">
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%A7%91%E5%88%9B%E6%9C%8D%E5%8A%A1/%E8%90%A5%E9%94%80%E5%88%9B%E6%96%B0%402x%20%281%29.png"
								alt="" />
							<div class="fwcx-title">营销创新</div>
						</div>
					</div>
					<div class="flex alit">
						<div class="kcfw-list">{{kcfwData[0]}}个发展区县</div>
						<div class="kcfw-list">{{kcfwData[1]}}个重点加工园区</div>
					</div>
					<div class="flex alit">
						<div class="kcfw-list">{{kcfwData[2]}}个重点招商项目</div>
						<div class="kcfw-list">{{kcfwData[3]}}个重点在建产业项目</div>
					</div>
					<div class="flex alit">
						<div class="kcfw-list">{{kcfwData[4]}}个重点企业</div>
						<div class="kcfw-list">{{kcfwData[5]}}个高校协同创新平台</div>
					</div>
					<div class="flex alit">
						<div class="kcfw-list">{{kcfwData[6]}}个科研院所协同创新平台</div>
						<div class="kcfw-list">{{kcfwData[7]}}个产业创新联合体</div>
					</div>
					<div class="flex alit">
						<div class="kcfw-list">{{kcfwData[8]}}个公共技术服务平台</div>
						<div class="kcfw-list">{{kcfwData[9]}}个知识产权运营服务中心</div>
					</div>
				</div>
				<div class="flex justb alit" style="margin-bottom: 10px;" @click="socialDetailClick">
					<div class="data-time">更新时间：{{yesterDay}}</div>
					<div class="xq" v-if="tabbarIndex3 == 1 || tabbarIndex3 == 2 || tabbarIndex3 == 5">详情 ></div>
				</div>
			</div>

			<div class="title" style="margin: 20px 0 5px 0;">
				<div class="">企业侧</div>
			</div>
			<div class="info-style" style="padding-bottom: 0 !important;">
				<div class="flex justb">
					<div class="flexCol alit justc" :class="tabbarIndex4 == 1 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex4 = 1">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%B8%BB%E4%BD%93%E5%9F%B9%E8%82%B2%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex4 == 1" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E4%B8%BB%E4%BD%93%E5%9F%B9%E8%82%B2.png"
							alt="" v-else />
						<div class="">主体培育</div>
					</div>
					<div class="flexCol alit justc" :class="tabbarIndex4 == 2 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex4 = 2,changeSzhzx(1)">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E6%95%B0%E5%AD%97%E5%8C%96%E8%BD%AC%E5%9E%8B%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex4 == 2" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E6%95%B0%E5%AD%97%E5%8C%96%E8%BD%AC%E5%9E%8B.png"
							alt="" v-else />
						<div class="">数字化转型</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex4 == 3 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex4 = 3">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E7%BB%BF%E8%89%B2%E5%8F%91%E5%B1%95%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex4 == 3" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E7%BB%BF%E8%89%B2%E5%8F%91%E5%B1%95.png"
							alt="" v-else />
						<div class="">绿色发展</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex4 == 4 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex4 = 4,changeJszr(1)">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E6%8A%80%E6%9C%AF%E8%BD%AC%E8%AE%A9%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex4 == 4" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E6%8A%80%E6%9C%AF%E8%BD%AC%E8%AE%A9.png"
							alt="" v-else />
						<div class="">技术转让</div>
					</div>
					<div class="flexCol alit justc " :class="tabbarIndex4 == 5 ? 'check' : 'tabbar-defalut'"
						@click="tabbarIndex4 = 5">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E7%BB%8F%E8%90%A5%E6%9C%8D%E5%8A%A1%E7%82%B9%E5%87%BB.png"
							alt="" v-if="tabbarIndex4 == 5" />
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E7%BB%8F%E8%90%A5%E6%9C%8D%E5%8A%A1.png"
							alt="" v-else />
						<div class="">经营服务</div>
					</div>
				</div>
				<div class="flex justb" style="margin: 10px 0;" v-if="tabbarIndex4 == 2">
					<div :class="tabbarChildIndex4 == 1 ? 'check2' : 'check2-defalut'" @click="changeSzhzx(1)">火锅企业
					</div>
					<div :class="tabbarChildIndex4 == 2 ? 'check2' : 'check2-defalut'" @click="changeSzhzx(2)">生产制造
					</div>
					<div :class="tabbarChildIndex4 == 3 ? 'check2' : 'check2-defalut'" @click="changeSzhzx(3)">供应链企业
					</div>
					<div :class="tabbarChildIndex4 == 4 ? 'check2' : 'check2-defalut'" @click="changeSzhzx(4)">仓储配送
					</div>
					<div :class="tabbarChildIndex4 == 5 ? 'check2' : 'check2-defalut'" @click="changeSzhzx(5)">农业企业
					</div>
				</div>
				<div class="flex justb" style="margin: 10px 0;" v-if="tabbarIndex4 == 4">
					<div :class="tabbarChildIndex4 == 1 ? 'check2' : 'check2-defalut'" @click="changeJszr(1)">火锅企业
					</div>
					<div :class="tabbarChildIndex4 == 2 ? 'check2' : 'check2-defalut'" @click="changeJszr(2)">生产制造
					</div>
					<div :class="tabbarChildIndex4 == 3 ? 'check2' : 'check2-defalut'" @click="changeJszr(3)">供应链企业
					</div>
					<div :class="tabbarChildIndex4 == 4 ? 'check2' : 'check2-defalut'" @click="changeJszr(4)">仓储配送
					</div>
					<div :class="tabbarChildIndex4 == 5 ? 'check2' : 'check2-defalut'" @click="changeJszr(5)">农业企业
					</div>
				</div>
				<div class="flex" style="margin-top: 20px;" v-if="tabbarIndex4 == 1">
					<div class="">
						<div class="td">
							<div class="tdpy">梯度培育</div>
							<div class="tdbg"></div>
						</div>
						<div class="td-info flexCol alit justb">
							<div class="text1">上市企业 13家</div>
							<div class="text2">单项冠军 47家</div>
							<div class="text3">小巨人 89家</div>
							<div class="text4">专精特新 322 家</div>
							<div class="text5">创新型中小企业 1387 家</div>
						</div>

					</div>
					<div class="" style="margin-left: 10px;">
						<div class="td">
							<div class="tdpy">创新发展</div>
							<div class="tdbg"></div>
						</div>
						<div class="cxfz flex alit justc" style="margin-top: 5px;">
							<div class="flexCol alit sjqy">
								<div class="num flex alit justc">
									66家
								</div>
								<div class="" style="width: 80%;">市级企业技术中心</div>
							</div>
							<div class="flexCol alit gyhxxh">
								<div class="num flex alit justc">
									17家
								</div>
								<div class="" style="width: 80%;">工业和信息化重点实验室</div>
							</div>
							<div class="flexCol alit sjzzy">
								<div class="num flex alit justc">
									34家
								</div>
								<div class="" style="width: 80%;">市级制造业创新中心</div>
							</div>
						</div>
					</div>
				</div>
				<div class="" v-if="tabbarIndex4 == 3">
					<lsfz></lsfz>
				</div>

				<div class="fw-content szhzxhei" style="overflow: hidden;"
					v-if="tabbarIndex4 == 2 || tabbarIndex4 == 4">
					<!-- <div class="list" v-for="item in szhzxList">
						<div class="">企业:{{item.company_name}}</div>
						<div class="">数字技术:{{item.digital_technology}}</div>
						<div class="" v-if="tabbarIndex4 == 2">联系电话:{{item.contact_info}}</div>
						<div class="" v-if="tabbarIndex4 == 4">联系邮箱:{{item.contact_info}}</div>
					</div> -->
					<div class=""
						style="width: 98%;border: 1px solid !important; border-image: linear-gradient(270deg, rgba(1, 194, 255, 1), rgba(1, 194, 255, 0)) 1 1 !important;">
						<table>
							<thead>
								<tr style="background-color: rgba(69, 108, 239, 0.3);text-align: center;">
									<td style="width: 40%;">企业名称</td>
									<td style="width: 35%;">数字技术</td>
									<td style="width: 25%;" v-if="tabbarIndex4 == 2">联系电话</td>
									<td style="width: 25%;" v-if="tabbarIndex4 == 4">联系邮箱</td>
								</tr>
							</thead>
							<tbody>
								<tr class="zxlist2" v-for="item in szhzxList">
									<td style="width: 40%;height: 30px;">{{item.company_name}}</td>
									<td style="width: 35%;">{{item.digital_technology}}</td>
									<td style="width: 25%;">{{item.contact_info}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="" v-if="tabbarIndex4 == 5">
					<jyfw></jyfw>
				</div>
				<div class="fw-content szhzxhei" v-if="tabbarIndex4 == 6" style="margin-top: 10px;">
					基础服务标准 <br />
					1、严格选材，每日采购新鲜内脏（如毛肚、鸭肠）、肉类及蔬菜，确保食材新鲜度；部分企业采用非遗食材提升地域特色。 <br />
					2、锅底标准化，通过自动化生产线实现底料生产的精准控制，例如德庄全辣度火锅通过科学分级辣度，推出从12度到75度的标准化产品，满足不同辣度需求。 <br />
					3、食品安全追溯，推广“阳光厨房”建设，加强食材溯源管理，部分企业通过智能传感器监控生产过程。 <br />
					4、规范化服务流程，通过重庆火锅学院等机构开展职业培训，涵盖调料制作、服务礼仪、菜品知识等，并设立火锅料理师国家职业标准。建立服务监督制度与奖惩体系，确保服务流程执行到位，提升员工积极性。
					<br />
					<br />
					特色增值服务 <br />
					1、个性化服务，定制需求，提供鸳鸯锅、清汤锅等多样化锅底选择；根据顾客口味推荐菜品组合，配备儿童餐具及专属菜品。场景适配，部分门店推出复古换装体验、吼堂迎客等沉浸式文化服务，增强用餐趣味性。
					<br />
					2、非遗元素植入，如北步园老火锅还原陪都时期的市井风貌，同堂火锅结合老舍文化打造“文化会客厅”。 <br />
					3、主题场景设计，南山火锅小镇将自然景观与火锅结合，推出森林露天火锅、吊脚楼夜景火锅等特色场景。 <br />
					<br />
					质量监控与优化 <br />
					1、顾客评价管理，鼓励线上好评分享，邀请美食博主探店测评，利用社交媒体收集反馈。 <br />
					2、会员数据分析，通过会员系统记录消费偏好，推送个性化优惠活动，提升复购率。 <br />
					3、菜品迭代，定期推出爆品（如年白特色大鱿鱼），结合季节时令更新菜单。 <br />
					4、服务细节优化，关注年轻群体需求，如外卖火锅套餐、单人冒菜等便捷形式。 <br />
					<br />
					创新经营模式 <br />
					1、线上线下融合，发展直播电商、在线展览，通过小程序实现扫码点餐、预约排号等智慧服务。 <br />
					2、数据驱动运营，运用大数据分析消费者行为，指导供应链管理和精准营销。 <br />
					3、IP联名，与热门影视、动漫合作推出主题火锅店或限定菜品。 <br />
					4、伴手礼开发，销售包装精美的底料、特产食材作为旅游纪念品。
				</div>
				<div class="flex justb alit" style="margin-bottom: 0px;" @click="tabbarIndex4 == 2 && openSzhzxCase()">
					<div class="data-time">更新时间：{{yesterDay}}</div>
					<div class="xq" v-if="tabbarIndex4 == 2">详情 ></div>
				</div>
			</div>
		</div>


		<div class="modal flexCol alit justc" v-if="personal" @click.stop="personal = false">
			<iframe src="https://h5.huoguogo.cn/#/talent/pages/index/index"
				style="height: 80vh;width: 20vw;border-radius: 10px;" frameborder="0"></iframe>
		</div>
		<div class="modal flexCol alit justc" v-if="luyu" @click.stop="luyu = false">
			<iframe src="https://h5.huoguogo.cn/#/pages/index/activity/luyu"
				style="height: 80vh;width: 20vw;border-radius: 10px;" frameborder="0"></iframe>
		</div>
		<div class="modal flexCol alit justc" v-if="pdfVisible" @click.stop="closePdf">
			<div class="pdf-dialog" @click.stop>
				<div class="pdf-head">
					<div class="pdf-title">{{ pdfTitle }}</div>
					<div class="pdf-close" @click="closePdf">×</div>
				</div>
				<div class="pdf-body">
					<div class="pdf-tip" v-if="pdfLoading">PDF 加载中…</div>
					<iframe v-else-if="pdfUrl" class="pdf-frame" :src="pdfUrl" frameborder="0"></iframe>
				</div>
			</div>
		</div>
		<szhzx-case v-if="szhzxCaseVisible" @close="szhzxCaseVisible = false"></szhzx-case>
		<food-safety-analysis v-if="foodSafetyVisible" @close="foodSafetyVisible = false"></food-safety-analysis>
		<finance-analysis v-if="financeVisible" @close="financeVisible = false"></finance-analysis>
		
		
		<el-dialog title="提示" :visible.sync="dialogOpenSasy" width="70%" top="0%" :append-to-body="true">
			<span slot="title"></span>
			<div class="mySeamlessScrollStyle" style="padding: 0px ;">
				<!-- <div style="position: absolute;top: 4px;left: 45%;color: #FFFFFF;font-size: 22px;font-weight: bold;">
					食安溯源</div> -->
					<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/92614b6fc03642ea711f538ff3756f3c.jpg" style="width: 100%;" alt="" />
			</div>
			
			<span slot="footer"></span>
		</el-dialog>
		<IndustryOperationDetails
			:visible="operationDetailsVisible"
			:dataset="operationData"
			:loading="operationLoading"
			:error="operationError"
			@close="operationDetailsVisible = false"
			@retry="loadIndustryOperation"
		/>

		<!-- 政策服务详情弹窗（参考能力中心 AI 内容弹窗） -->
		<div class="popup-mask" v-if="policyDetail" @click="closePolicyDetail"></div>
		<div class="policy-popup" v-if="policyDetail">
			<div class="popup-close" @click="closePolicyDetail">&times;</div>
			<div class="policy-popup-title">{{ policyDetail.name }}</div>
			<div class="policy-popup-meta">
				<span v-if="policyDetail.categoryText">{{ policyDetail.categoryText }}</span>
				<span v-if="policyDetail.docNo">{{ policyDetail.docNo }}</span>
				<span v-if="policyDetail.issuer">{{ policyDetail.issuer }}</span>
				<span v-if="policyDetail.publishDate || policyDetail.periodText">{{ policyDetail.publishDate || policyDetail.periodText }}</span>
			</div>
			<div class="policy-popup-body">
				<div class="policy-detail-loading" v-if="policyDetailLoading">详情加载中…</div>
				<template v-else>
					<p v-if="policyDetail.summary" class="policy-summary">{{ policyDetail.summary }}</p>
					<div v-if="policyDetail.content" class="policy-rich" v-html="policyDetail.content"></div>
					<p v-if="!policyDetail.summary && !policyDetail.content" class="policy-empty">暂无更多详情内容</p>
				</template>
			</div>
			<div class="policy-popup-footer" v-if="policyDetail.sourceUrl || policyDetail.fileUrl">
				<a v-if="policyDetail.sourceUrl" class="policy-source-link" :href="policyDetail.sourceUrl" target="_blank" rel="noopener noreferrer">查看原文 ↗</a>
				<a v-if="policyDetail.fileUrl" class="policy-source-link" style="margin-left: 18px;" :href="policyDetail.fileUrl" target="_blank" rel="noopener noreferrer">下载附件 ↗</a>
			</div>
		</div>

		<!-- 产业招商详情弹窗（与政策详情同款视觉） -->
		<div class="popup-mask" v-if="investDetail" @click="closeInvestDetail"></div>
		<div class="policy-popup" v-if="investDetail">
			<div class="popup-close" @click="closeInvestDetail">&times;</div>
			<div class="policy-popup-title">{{ investDetail.name }}</div>
			<div class="policy-popup-meta">
				<span v-if="investDetail.location">{{ investDetail.location }}</span>
				<span v-if="investDetail.sourceType">{{ investDetail.sourceType }}</span>
				<span v-if="investDetail.infoDate || investDetail.periodText">{{ investDetail.infoDate || investDetail.periodText }}</span>
			</div>
			<div class="policy-popup-body">
				<div class="policy-detail-loading" v-if="investDetailLoading">详情加载中…</div>
				<template v-else>
					<p v-if="investDetail.bizScope" class="policy-summary">{{ investDetail.bizScope }}</p>
					<div v-if="investDetail.keyInfo" class="invest-field"><b>关键信息：</b>{{ investDetail.keyInfo }}</div>
					<div v-if="investDetail.usageTip" class="invest-field"><b>使用提示：</b>{{ investDetail.usageTip }}</div>
					<div v-if="investDetail.content" class="policy-rich" v-html="investDetail.content"></div>
					<p v-if="!investDetail.bizScope && !investDetail.keyInfo && !investDetail.content" class="policy-empty">暂无更多详情内容</p>
				</template>
			</div>
			<div class="policy-popup-footer" v-if="investDetail.sourceUrl">
				<a class="policy-source-link" :href="investDetail.sourceUrl" target="_blank" rel="noopener noreferrer">查看原文 ↗</a>
			</div>
		</div>

		<!-- 标准规范详情弹窗（与政策/招商详情同款视觉） -->
		<div class="popup-mask" v-if="standardDetail" @click="closeStandardDetail"></div>
		<div class="policy-popup" v-if="standardDetail">
			<div class="popup-close" @click="closeStandardDetail">&times;</div>
			<div class="policy-popup-title">{{ standardDetail.name }}</div>
			<div class="policy-popup-meta">
				<span v-if="standardDetail.standardNo">{{ standardDetail.standardNo }}</span>
				<span v-if="standardDetail.level">{{ standardDetail.level }}</span>
				<span v-if="standardDetail.issuer">{{ standardDetail.issuer }}</span>
				<span v-if="standardDetail.validStatus">{{ standardDetail.validStatus }}</span>
				<span v-if="standardDetail.publishDate || standardDetail.periodText">{{ standardDetail.publishDate || standardDetail.periodText }}</span>
			</div>
			<div class="policy-popup-body">
				<div class="policy-detail-loading" v-if="standardDetailLoading">详情加载中…</div>
				<template v-else>
					<p v-if="standardDetail.relation" class="policy-summary">{{ standardDetail.relation }}</p>
					<div v-if="standardDetail.effectiveDate" class="invest-field"><b>实施日期：</b>{{ standardDetail.effectiveDate }}</div>
					<div v-if="standardDetail.content" class="policy-rich" v-html="standardDetail.content"></div>
					<p v-if="!standardDetail.relation && !standardDetail.content" class="policy-empty">暂无更多详情内容</p>
				</template>
			</div>
			<div class="policy-popup-footer" v-if="standardDetail.sourceUrl || standardDetail.fileUrl">
				<a v-if="standardDetail.sourceUrl" class="policy-source-link" :href="standardDetail.sourceUrl" target="_blank" rel="noopener noreferrer">查看原文 ↗</a>
				<a v-if="standardDetail.fileUrl" class="policy-source-link" style="margin-left: 18px;" :href="standardDetail.fileUrl" target="_blank" rel="noopener noreferrer">下载附件 ↗</a>
			</div>
		</div>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="80%" top="1%" :append-to-body="true">
			<span slot="title"></span>
			<div class="mySeamlessScrollStyle" v-if="rightTopScreen"  style="overflow: hidden;">
				<div class="trade-dialog-switch">
					<div class="trade-dialog-switch__item" :class="{'trade-dialog-switch__item--active': tradeDialogTab === 'realtime'}"
						@click="tradeDialogTab = 'realtime'">实时交易数据</div>
					<div class="trade-dialog-switch__item" :class="{'trade-dialog-switch__item--active': tradeDialogTab === 'category'}"
						@click="tradeDialogTab = 'category'">品类统计</div>
				</div>
				<div v-if="tradeDialogTab === 'realtime'">
				<table class="customTable">
					<thead>
						<tr class="trtdstyle">
							<th>下单账户</th>
							<th>公司名称</th>
							<th>产品名称</th>
							<th>订单金额</th>
							<th>商品数量</th>
							<!-- <th>订单状态</th> -->
							<th>下单时间</th>
						</tr>
					</thead>
				</table>
				<vue-seamless-scroll :data="rightTopScreen" :class-option="scrollOption" class="scrollStyle">
					<!-- 里面的内容完全自定义 -->
					<table class="customTable">
						<tbody>
							<tr v-for="(item, index) in rightTopScreen" :key="index" style="display:flex;height: 70px;"
								class="trtdstyle" @click="handleButton(item)">
								<td class="textOne">
									<!-- {{item.shopName ? item.shopName : item.nickname}} -->
									{{changeShowText(item.shopName ? item.shopName : item.nickname)}}
								</td>
								<td class="textOne" style="font-weight: bold;">
									{{changeShowText(item.shopName)}}
								</td>
								<td style="" class="textOne">{{item.spuName}}
								</td>
								<td style="">{{item.payPrice / 100}}</td>
								<td style="">{{item.num}}</td>
								<td style="">{{item.formattedCreateTime}}</td>
							</tr>
						</tbody>
					</table>
				</vue-seamless-scroll>
				</div>
				<div v-else class="trade-chart-wrap">
					<category-trade-stats />
				</div>
			</div>
			<span slot="footer"></span>
		</el-dialog>
		
		<el-dialog title="提示" :visible.sync="dialogVisible2" width="80%" top="1%" :append-to-body="true">
			<span slot="title"></span>
			<div class="mySeamlessScrollStyle" style="overflow: hidden;">
				<div style="position: absolute;top: 4px;left: 45%;color: #FFFFFF;font-size: 22px;font-weight: bold;">
					入驻企业</div>
				<table class="customTable">
					<thead>
						<tr class="trtdstyle">
							<th>企业名称</th>
							<th> 企业类型</th>
							<th>入驻时间</th>
						</tr>
					</thead>
				</table>
				<vue-seamless-scroll :data="shopListInfo" :class-option="scrollOption" class="scrollStyle">
					<!-- 里面的内容完全自定义 -->
					<table class="customTable">
						<tbody>
							<tr v-for="(item, index) in shopListInfo" :key="index" style="display:flex;height: 70px;"
								class="trtdstyle" @click="handleButton(item)">
								<td class="textOne" >
									{{changeShowText(item.enterpriseName)}}
		
								</td>
								<td class="textOne" style="font-weight: bold;">{{item.tradeIdentity}}
								</td>
								<td style="" class="textOne">{{utils.changeTime(item.createTime) }}
								</td>
							</tr>
						</tbody>
					</table>
				</vue-seamless-scroll>
			</div>
			<span slot="footer"></span>
		</el-dialog>
		
		
	</div>

</template>

<script>
	import centerMap from './centerMap.vue'
	import countTo from 'vue-count-to';
	import vueSeamlessScroll from 'vue-seamless-scroll'

	import leftTop from './homeLeft/leftTop.vue'
	import IndustryOperationDetails from './homeLeft/IndustryOperationDetails.vue'
	import industryOperation from './homeLeft/industryOperation'
	import homeRight1 from './homeRight/rightTop1.vue'
	import homeRight2 from './homeRight/rightTop2.vue'
	import homeRight3 from './homeRight/rightTop3.vue'

	import rightTop from './homeRight/rightTop.vue'
	import bottomCenter from './homeBottom/bottomCenter.vue'
	import bottomRight from './homeBottom/bottomRight.vue'
	import yjjc from './yjjc.vue'
	import jrfw from './jrfw/jrfw.vue'
	import xy from './xy+/xy+.vue'
	import lsfz from './lsfz/lsfz.vue'
	import jyfw from './jyfw/jyfw.vue'
	import CategoryTradeStats from './CategoryTradeStats.vue'
	import szhzxCase from './szhzxCase.vue'
	import FoodSafetyPanel from './homeRight/FoodSafetyPanel.vue'
	import FoodSafetyAnalysis from './homeRight/FoodSafetyAnalysis.vue'
	import FinanceAnalysis from './homeRight/FinanceAnalysis.vue'
	export default {
		mixins: [industryOperation],
		components: {
			IndustryOperationDetails,
			szhzxCase,
			FoodSafetyPanel,
			FoodSafetyAnalysis,
			FinanceAnalysis,
			CategoryTradeStats,
			jyfw,
			lsfz,
			xy,
			yjjc,
			jrfw,
			bottomRight,
			bottomCenter,
			rightTop,
			centerMap,
			countTo,
			vueSeamlessScroll,
			leftTop,
			homeRight1,
			homeRight2,
			homeRight3
		},
		data() {
			return {
				dialogOpenSasy:false,
				tabbarIndex1: 1,
				tabbarChildIndex1: 1,
				cyyxScenarios: null,
				tabbarIndex2: 1,
				tabbarChildIndex2: 1,
				tabbarIndex3: 1,
				tabbarChildIndex3: 1,
				tabbarIndex4: 1,
				tabbarChildIndex4: 1,
				tpScList: null,
				zcfwText: '',
				// 政策服务：分类计数（summary typeCounts，缺接口时保留演示值）
				policyCounts: { 1: 8, 2: 7, 3: 9 },
				// 政策列表（page 接口一次拉第1页 pageSize=100，前端按分类过滤）
				policyAll: [],
				policyLoading: false,
				policyDetail: null,
				policyDetailLoading: false,
				// 产业招商：分类计数 / 列表 / 详情（与政策服务同逻辑）
				investCounts: { 1: 14, 2: 11, 3: 8, 4: 10 },
				investAll: [],
				investLoading: false,
				investDetail: null,
				investDetailLoading: false,
				// 标准规范：分类计数 / 列表 / 详情（与政策服务、产业招商同逻辑）
				standardCounts: { 1: 2, 2: 173, 3: 106, 4: 29, 5: 0 },
				standardAll: [],
				standardLoading: false,
				standardDetail: null,
				standardDetailLoading: false,
				xmjsText: [],
				leftTwo: '',
				szhzxList: [],
				bzgfList: [],
				kcfwData: [64, 12, 27, 19, 71, 18, 9, 22, 59, 7],
				yesterDay: '',
				luyu: false,
				szhzxCaseVisible: false,
				personal: false,
				financeVisible: false,
				foodSafetyVisible: false,
				// 展商名录 PDF 页内预览
				pdfVisible: false,
				pdfUrl: '',
				pdfTitle: '',
				pdfLoading: false,
				pdfBlobUrl: '',
				dialogVisible2: false,
				dialogVisible: false,
				tradeDialogTab: 'realtime',
				rightTopScreen: null,
				shopListInfo:null,
				scrollOption: {
					direction: 1, //配置属性向下滚动
					limitMoveNum: 8,
					singleHeight: 70
				},
			}
		},
		computed: {
			// 当前选中分类（1产业政策/2金融政策/3指导意见）对应的政策列表
			policyList() {
				const t = Number(this.tabbarChildIndex1)
				return (this.policyAll || []).filter(p => Number(p.type) === t)
			},
			// 当前选中招商分类（1供应链/2加工企业/3物流/4品牌加盟）对应的招商列表
			investList() {
				const t = Number(this.tabbarChildIndex1)
				return (this.investAll || []).filter(p => Number(p.type) === t)
			},
			// 当前选中标准分类（1国家/2食材/3行业/4准入/5技术）对应的标准列表
			standardList() {
				const t = Number(this.tabbarChildIndex2)
				return (this.standardAll || []).filter(s => Number(s.type) === t)
			}
		},
		async created() {
			let that = this
			if (this.$route.query.accessToken || sessionStorage.getItem('accessToken')) {
				if (this.$route.query.accessToken) {
					let token = this.$route.query.accessToken
					this.$request2(`/admin-api/system/auth/validateToken?accessToken=${token}`).then(res => {
						if (!res.data) {
							this.$message.error('请先登录');
							this.$router.replace('/login')
						}
					})
				}
			} else {
				this.$message.error('请先登录');
				this.$router.replace('/login')
			}
			this.changeTp(1)

			// 首页-左2-产业概况
			this.$request('/center/home/leftTwo').then(res => {
				this.leftTwo = res.data
			})
			this.getYesterdayDate()
			
			this.$request2('/admin-api/trade/order/realTimeTrading').then(res => {
				this.rightTopScreen = res.data
			})
			setInterval(() => {
				that.$request2('/admin-api/trade/order/realTimeTrading').then(res => {
					that.rightTopScreen = res.data
				})
			}, 10000);
			
			this.$request2('/admin-api/shop/info/list-center').then(res => {
				this.shopListInfo = this.formatShopListInfo(res.data)
			})
			this.getCyyxData()
			this.loadPolicySummary()
			this.loadPolicies()
			this.loadInvestSummary()
			this.loadInvests()
			this.loadStandardSummary()
			this.loadStandards()
		},
		destroyed() {

		},
		methods: {
			openSzhzxCase() {
				this.szhzxCaseVisible = true
			},
			// 社会侧底部「详情」按当前 tab 分发到对应弹窗
			socialDetailClick() {
				if (this.tabbarIndex3 == 1) {
					this.personal = true
				} else if (this.tabbarIndex3 == 2) {
					this.financeVisible = true
				} else if (this.tabbarIndex3 == 5) {
					this.foodSafetyVisible = true
				}
			},
			// 展商名录 PDF：OBS 默认域名强制 attachment，iframe 直链只能下载；
			// 改为 fetch 拉成 blob 再生成 blob: 地址（天然 inline）交给 iframe 渲染。需桶允许本站跨域。
			openExhibitorPdf(year) {
				const urlMap = {
					'2025': 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/hotPotV3/%E5%A4%A7%E5%B1%8F/2025%E5%B9%B4%E5%B1%95%E5%95%86%E5%90%8D%E5%BD%95.pdf',
					'2026': 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/hotPotV3/%E5%A4%A7%E5%B1%8F/2026%20%E5%B1%95%E5%95%86%E5%90%8D%E5%BD%95.pdf'
				}
				const url = urlMap[year]
				if (!url) return
				this.pdfTitle = year + '年展商名录'
				this.pdfUrl = ''
				this.pdfLoading = true
				this.pdfVisible = true
				fetch(url).then(resp => {
					if (!resp.ok) throw new Error('HTTP ' + resp.status)
					return resp.blob()
				}).then(blob => {
					this.pdfBlobUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }))
					this.pdfUrl = this.pdfBlobUrl
					this.pdfLoading = false
				}).catch(() => {
					this.pdfVisible = false
					this.pdfLoading = false
					window.open(url, '_blank')
					this.$message && this.$message('预览加载失败（可能是桶未开跨域），已新窗口打开')
				})
			},
			closePdf() {
				this.pdfVisible = false
				this.pdfUrl = ''
				this.pdfLoading = false
				if (this.pdfBlobUrl) {
					URL.revokeObjectURL(this.pdfBlobUrl)
					this.pdfBlobUrl = ''
				}
			},
			formatShopListInfo(list) {
				if (!Array.isArray(list)) {
					return []
				}
				return list.map(item => {
					const createTime = this.normalizeShopCreateTime(item.createTime)
					return {
						...item,
						createTime
					}
				}).sort((a, b) => new Date(b.createTime).getTime() - new Date(a.createTime).getTime())
			},
			normalizeShopCreateTime(createTime) {
				if (!createTime) {
					return createTime
				}
				const now = new Date()
				const sourceDate = new Date(createTime)
				if (Number.isNaN(sourceDate.getTime())) {
					return createTime
				}
				if (sourceDate.getFullYear() >= 2025) {
					return createTime
				}
				const adjustedDate = new Date(sourceDate)
				adjustedDate.setFullYear(2026)
				if (adjustedDate.getTime() > now.getTime()) {
					return this.formatDateTime(this.getRandomDateIn2026(now))
				}
				return this.formatDateTime(adjustedDate)
			},
			getRandomDateIn2026() {
				const start = new Date('2026-01-01 00:00:00')
				const end = new Date('2026-06-30 23:59:59')
				const minTime = start.getTime()
				const maxTime = end.getTime()
				if (maxTime <= minTime) {
					return start
				}
				const randomTime = Math.floor(Math.random() * (maxTime - minTime + 1)) + minTime
				return new Date(randomTime)
			},
			formatDateTime(date) {
				const year = date.getFullYear()
				const month = String(date.getMonth() + 1).padStart(2, '0')
				const day = String(date.getDate()).padStart(2, '0')
				const hours = String(date.getHours()).padStart(2, '0')
				const minutes = String(date.getMinutes()).padStart(2, '0')
				const seconds = String(date.getSeconds()).padStart(2, '0')
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
			},
			openSyMechart(){
				window.open('https://sy.18yimu.com/')
			},
			changeShowText(e) {
				if (e.length <= 6) {
					//保留前1后1
					let start = e.substring(0, 1)
					let end = e.substring(e.length - 1, e.length)
					return start + '****' + end
				} else {
					// 前2后2
					let start = e.substring(0, 3)
					let end = e.substring(e.length - 2, e.length)
					return start + '****' + end
				}
			},
			getYesterdayDate() {
				// 创建一个日期对象，表示当前时间
				const today = new Date();

				// 更新时间展示当前日期（原为减一天）
				const yesterday = new Date(today);
				yesterday.setDate(today.getDate());

				// 获取年、月、日
				const year = yesterday.getFullYear();
				const month = String(yesterday.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要+1
				const day = String(yesterday.getDate()).padStart(2, '0');

				// 返回格式化的日期字符串
				this.yesterDay = `${year}-${month}-${day}`;
			},
			changeIndex3(e) {
				this.tabbarChildIndex3 = e
				switch (e) {
					case 1:
						this.kcfwData = [64, 12, 27, 19, 71, 18, 9, 22, 59, 7]
						break;
					case 2:
						this.kcfwData = [31, 8, 15, 11, 44, 14, 7, 23, 36, 5]
						break;
					case 3:
						this.kcfwData = [29, 6, 19, 23, 52, 67, 19, 25, 42, 6]
						break;
					case 4:
						this.kcfwData = [65, 4, 9, 18, 37, 18, 9, 22, 59, 7]
						break;
					default:
						break;
				}
			},
			bzgfClickLegacy(index) {
				this.tabbarChildIndex2 = index
				this.bzgfList = []
				let that = this
				setTimeout(function() {
					switch (index) {
						case 1:
							that.bzgfList = [
								'《火锅底料质量通则》，对火锅底料的定义、产品分类进行了科学规范，从原料把控到成品出厂，全面覆盖产品要求、检验规则、标志标签、包装运输及贮存等环节，并对关键指标的检验方法作出详细说明。',
								'《火锅企业经营服务规范》，通过规范经营资质、卫生管理、原料采购等环节，引导行业健康发展。'
							]
							break;
						case 3:
							that.bzgfList = ['《火锅食材产品质量分级通则》，对火锅食材中的肉制品、水产制品、蔬菜制品、豆制品等进行了科学规范。',
								'12项火锅食材系列团体标准，采用“2+10”模式，由2个通用标准和10个典型火锅食材标准组成。2个通用标准：《火锅食材产品质量分级通则》和《火锅食材生产企业质量提升指南》。10个典型火锅食材标准：非发酵豆制品、肥肠、黄喉、凤爪、毛肚、鸭肠、牛油、调味油、火锅底料、速冻调理牛肉。',
								'原料资质准入，所有食材须具备合格证明（如检疫合格证、检测报告），肉类需标注动物产地及屠宰信息，拒绝来源不明食材。',
								'新鲜度强制标准，生鲜肉类应无淤血、异味，表面微干不黏手；叶菜类需叶片挺拔、无黄萎；水产类眼球饱满、鳃丝鲜红。',
								'农残与兽药残留限值，蔬菜农药残留量执行GB 2763《食品安全国家标准》，畜禽肉兽药残留符合GB 31650《食品安全国家标准》。',
								'食品添加剂使用规范，严禁超范围/超量添加防腐剂（如苯甲酸钠）、色素（胭脂红等）；底料中谷氨酸钠（味精）用量需明示。',
								'非食用物质黑名单，明确禁止使用工业火碱、福尔马林、苏丹红等非法添加物，不得检出甲醛次硫酸氢钠（吊白块）。',
								'食材分级标识，按质量等级划分（如特级/一级/二级），包装需标明产地、生产日期、保质期及储存条件（冷藏/冷冻）。',
								'预制半成品规范，速冻丸滑类需标注主料占比（如牛肉含量≥85%），禁止使用过期肉糜二次加工。'
							]
							break;
						case 2:
							that.bzgfList = [
								'《火锅企业经营服务规范》，明确“火锅”“火锅企业”等基础概念，将企业按经营模式分为单店与连锁两类。经营资质需具备卫生许可证、营业执照及税务登记证；环保设施须配备专业排污系统并建立餐厨垃圾处理制度；消防安全规定禁用易燃装修材料，建立火源管理制度；卫生管理要求饮用水符合GB 5749，员工持健康证上岗。',
								'厨房卫生分级管理，厨房需按功能分区（粗加工区、切配区、烹饪区），生熟分离；餐具消毒需符合《餐饮服务食品安全操作规范》，采用高温或紫外线消毒。',
								'冷链管理与保质期控制，冷冻食材需全程温控（≤-18℃），标注生产日期与保质期；开封后易腐食材（如豆腐）需当日使用完毕。',
								'底料熬制与添加剂使用，传统牛油/清汤底料需明示主要原料，禁止使用回收老油；食品添加剂（如增味剂）需符合GB 2760标准并公示用量。',
								'菜品份量与摆盘标准化，同类菜品份量误差不超过±5%，摆盘需符合企业标准图示，确保顾客体验一致性。',
								'明码标价与消费提示，菜单需标明单价、计费方式（如按份/称重），特殊收费项目（如调料费）需提前告知。',
								'客诉响应与应急处理，建立快速客诉机制（如30分钟内到场处理），突发食品安全事件需立即封存留样并上报监管部门。'
							]
							break;
						case 4:
							that.bzgfList = [
								'基础经营资质，需办理《营业执照》及《食品经营许可证》，其中后者需明确标注“餐饮服务”和“火锅类制售”经营范围。部分地区要求菌类供应商提供《食用菌产地证明》及《检验检疫合格证》。',
								'食品安全规范，需符合《餐饮服务食品安全操作规范》，配备专用食材冷藏柜（建议温度控制在0-4℃），菌类处理区须与其他食材加工区物理隔离',
								'消防验收证明，火锅类餐饮场所需通过消防部门检查，取得《公众聚集场所投入使用、营业前消防安全检查合格证》，通风系统需达到每小时换气8-10次的标准。',
								'员工健康管理，所有接触食材的员工必须持有有效《健康证》，建议建立每日晨检制度，体温检测覆盖率需达100%。',
								'品牌授权文件，若选择加盟模式，需查验品牌方的《商标注册证》及《特许经营备案证明》，确保加盟资质的合法性。',
								'供应商准入与索证索票，建立稳定供应链，肉类、蔬菜等食材需提供检疫合格证明及检测报告，拒绝无合法来源的食材。',
								'厨房功能分区明确，操作间需划分粗加工区、切配区、烹饪区、洗消区，生熟分开操作；配备专用清洗水池（至少3个：蔬菜、肉类、器皿）。',
								'通风排烟系统达标，安装符合GB 18483标准的油烟净化设备，定期清理维护记录留存备查；室内无异味扩散至用餐区。'
							]
							break;
					}
				})
			},
			bzgfClick(index) {
				this.tabbarChildIndex2 = index
				this.standardDetail = null
			},
			// 标准规范分类计数：/standard/summary 仅取 typeCounts（code 1-5）
			loadStandardSummary() {
				this.$request2('/admin-api/statistics/brain/standard/summary').then(res => {
					if (!res || res.code !== 0 || !res.data) return
					const value = res.data.value || res.data
					const counts = value && value.typeCounts
					if (!Array.isArray(counts)) return
					counts.forEach(c => {
						if (c && c.code >= 1 && c.code <= 5) {
							this.$set(this.standardCounts, c.code, c.count || 0)
						}
					})
				}).catch(() => {})
			},
			// 标准列表：/standard/page 只取第1页，pageSize=100，不传 type 拉全部后前端分类
			loadStandards() {
				this.standardLoading = true
				this.$request2('/admin-api/statistics/brain/standard/page', { params: { pageNo: 1, pageSize: 100 } }).then(res => {
					this.standardLoading = false
					if (!res || res.code !== 0 || !res.data) return
					const value = res.data.value || res.data
					const list = value && value.list
					if (Array.isArray(list)) this.standardAll = list
				}).catch(() => { this.standardLoading = false })
			},
			openStandardDetail(item) {
				if (!item) return
				this.standardDetail = item
				this.loadStandardDetail(item.id)
			},
			// 标准详情：列表 content 恒为 null，点开时按 id 取 /standard/get 的正文 value
			loadStandardDetail(id) {
				if (id === undefined || id === null || id === '') return
				this.standardDetailLoading = true
				this.$request2('/admin-api/statistics/brain/standard/get', { params: { id } }).then(res => {
					this.standardDetailLoading = false
					if (!res || res.code !== 0 || !res.data) return
					const value = res.data.value || res.data
					if (value && typeof value === 'object') {
						this.standardDetail = Object.assign({}, this.standardDetail, value)
					}
				}).catch(() => { this.standardDetailLoading = false })
			},
			closeStandardDetail() {
				this.standardDetail = null
				this.standardDetailLoading = false
			},
			changeJszr(index) {
				this.tabbarChildIndex4 = index
				this.szhzxList = []
				let that = this
				setTimeout(function() {
					switch (index) {
						case 1:
							that.szhzxList = [{
									"company_name": "海底捞国际控股有限公司",
									"digital_technology": "智能厨房自动化控制系统",
									"contact_info": "bd@haidilao.com"
								},
								{
									"company_name": "呷哺呷哺餐饮管理有限公司",
									"digital_technology": "AI菜品研发与标准化生产技术",
									"contact_info": "400-678-6789"
								},
								{
									"company_name": "巴奴毛肚火锅",
									"digital_technology": "无人化门店运营系统",
									"contact_info": "tech@banuhotpot.com"
								},
								{
									"company_name": "凑凑火锅·茶憩",
									"digital_technology": "会员大数据精准营销平台",
									"contact_info": "invest@coohe.cn"
								}
							]
							break;
						case 2:
							that.szhzxList = [{
									"company_name": "四川天味食品集团股份有限公司",
									"digital_technology": "火锅底料自动化生产线技术",
									"contact_info": "tech@tewayfood.com"
								},
								{
									"company_name": "福建安井食品股份有限公司",
									"digital_technology": "丸滑类制品冻干锁鲜技术",
									"contact_info": "sales@anwell.cc"
								},
								{
									"company_name": "重庆德庄实业（集团）有限公司",
									"digital_technology": "风味物质提取与复配技术",
									"contact_info": "biz@dezhuang.com"
								},
								{
									"company_name": "河南三全食品股份有限公司",
									"digital_technology": "柔性化小批量定制生产系统",
									"contact_info": "ipr@sanquan.com"
								}
							]
							break;
						case 3:
							that.szhzxList = [{
									"company_name": "蜀海(北京)食品有限公司",
									"digital_technology": "食材溯源区块链平台技术",
									"contact_info": "tech@shuhai.cn"
								},
								{
									"company_name": "美菜网",
									"digital_technology": "生鲜品类智能分拣系统",
									"contact_info": "openapi@meicai.cn"
								},
								{
									"company_name": "深圳望家欢农产品集团有限公司",
									"digital_technology": "冷链物流温控监测技术",
									"contact_info": "it@wjhgroup.com"
								},
								{
									"company_name": "上海一亩田网络科技有限公司",
									"digital_technology": "供应商协同管理SaaS平台",
									"contact_info": "api@ymtnl.com"
								}
							]
							break;
						case 4:
							that.szhzxList = [{
									"company_name": "京东冷链",
									"digital_technology": "无人化冷链仓储管理系统",
									"contact_info": "solution@jdcoldchain.com"
								},
								{
									"company_name": "顺丰冷运",
									"digital_technology": "新能源冷藏车调度算法",
									"contact_info": "partnership@sf-express.com"
								},
								{
									"company_name": "众萃物流",
									"digital_technology": "城市末端配送路径优化技术",
									"contact_info": "procurement@zhongcuwl.com"
								},
								{
									"company_name": "九曳供应链",
									"digital_technology": "温湿度实时监控硬件方案",
									"contact_info": "system@jiuyelogistics.com"
								}
							]
							break;
						case 5:
							that.szhzxList = [{
									"company_name": "宁夏原野现代农业有限公司",
									"digital_technology": "智能温室环境控制技术",
									"contact_info": "extension@yuanyenongye.com"
								},
								{
									"company_name": "内蒙古蒙都羊业食品有限公司",
									"digital_technology": "牲畜个体健康监测系统",
									"contact_info": "farming@mengdugroup.com"
								},
								{
									"company_name": "山东寿光蔬菜产业集团",
									"digital_technology": "无土栽培营养液配方技术",
									"contact_info": "seeds@shouguangveg.com"
								},
								{
									"company_name": "云南神农农业产业集团",
									"digital_technology": "病虫害AI识别预警系统",
									"contact_info": "training@ynshennong.com"
								}
							]

							break;
						default:
							break;
					}
				})
			},
			changeSzhzx(index) {
				this.tabbarChildIndex4 = index
				this.szhzxList = []
				let that = this
				setTimeout(function() {
					switch (index) {
						case 1:
							that.szhzxList = [{
									"company_name": "海底捞国际控股有限公司",
									"digital_technology": "智能厨房管理系统（自动控温/配料）",
									"contact_info": "400-810-8108"
								},
								{
									"company_name": "呷哺呷哺餐饮管理有限公司",
									"digital_technology": "AI菜品研发与口味优化系统",
									"contact_info": "400-678-6789"
								},
								{
									"company_name": "凑凑火锅·茶憩",
									"digital_technology": "会员大数据分析与精准营销平台",
									"contact_info": "400-920-9209"
								},
								{
									"company_name": "巴奴毛肚火锅",
									"digital_technology": "无人化点餐与机器人送餐系统",
									"contact_info": "0371-88886666"
								}
							]
							break;
						case 2:
							that.szhzxList = [{
									"company_name": "四川天味食品集团股份有限公司",
									"digital_technology": "自动化生产线控制（IoT设备联动）",
									"contact_info": "028-87812345"
								},
								{
									"company_name": "福建安井食品股份有限公司",
									"digital_technology": "风味物质光谱分析与配方优化系统",
									"contact_info": "0595-85367890"
								},
								{
									"company_name": "重庆德庄实业（集团）有限公司",
									"digital_technology": "质量追溯大数据平台（从原料到成品）",
									"contact_info": "023-67891234"
								},
								{
									"company_name": "河南三全食品股份有限公司",
									"digital_technology": "柔性生产调度系统（小批量定制）",
									"contact_info": "0371-67890123"
								}
							]

							break;
						case 3:
							that.szhzxList = [{
									"company_name": "蜀海(北京)食品有限公司",
									"digital_technology": "智慧农批交易平台（B2B在线交易）",
									"contact_info": "010-67891234"
								},
								{
									"company_name": "美菜网",
									"digital_technology": "生鲜品类AI质检（图像识别瑕疵）",
									"contact_info": "400-158-1581"
								},
								{
									"company_name": "深圳望家欢农产品集团有限公司",
									"digital_technology": "需求预测算法（动态库存调配）",
									"contact_info": "0755-88889999"
								},
								{
									"company_name": "上海一亩田网络科技有限公司",
									"digital_technology": "区块链电子签收单（全程溯源）",
									"contact_info": "021-67890123"
								}
							]
							break;
						case 4:
							that.szhzxList = [{
									"company_name": "京东冷链",
									"digital_technology": "无人分拣仓库（AGV机器人）",
									"contact_info": "400-606-5500"
								},
								{
									"company_name": "顺丰冷运",
									"digital_technology": "车载温湿度实时监控系统",
									"contact_info": "400-811-1111"
								},
								{
									"company_name": "众萃物流",
									"digital_technology": "新能源冷藏车队管理平台",
									"contact_info": "400-999-8866"
								},
								{
									"company_name": "九曳供应链",
									"digital_technology": "城市配送路线规划系统",
									"contact_info": "13800138000"
								}
							]
							break;
						case 5:
							that.szhzxList = [{
									"company_name": "宁夏原野现代农业有限公司",
									"digital_technology": "智能温室控制系统（环境参数自动调节）",
									"contact_info": "0951-68234567"
								},
								{
									"company_name": "内蒙古蒙都羊业食品有限公司",
									"digital_technology": "牲畜耳标追踪系统（个体健康档案）",
									"contact_info": "0471-3867555"
								},
								{
									"company_name": "山东寿光蔬菜产业集团",
									"digital_technology": "土壤墒情监测传感器网络",
									"contact_info": "0536-87654321"
								},
								{
									"company_name": "云南神农农业产业集团",
									"digital_technology": "无人机植保与生长监测",
									"contact_info": "0871-67890123"
								}
							]

							break;

						default:
							break;
					}
				}, 0)
			},
			changeXmjs(index) {
				let that = this
				this.tabbarChildIndex2 = index
				this.xmjsText = []
				setTimeout(function() {
					switch (index) {
						case 1:
							that.xmjsText = ["地域特色挖掘：结合本地历史文化元素设计主题街区，如仿古街市、民俗村落等，强化地域辨识度",
								"多功能业态融合：将火锅消费与演艺、非遗体验、文创市集等结合，形成综合性文旅目的地",
								"智能化服务系统：引入智能导览、线上预约排队、虚拟点餐等技术提升游客体验",
								"文化展示空间：设置火锅博物馆、数字体验馆等，通过多媒体手段呈现火锅历史与制作工艺",
								"节庆活动标准化：定期举办火锅美食节、技能大赛等活动，形成品牌IP效应",
								"服务质量管控：制定文旅服务标准手册，涵盖接待流程、投诉处理、安全保障等环节"
							]
							break;
						case 2:
							that.xmjsText = ["种养植标准化：推行农产品标准化种植/养殖规程，重点把控农药残留、饲料添加剂使用等指标",
								"规模化布局：集中连片开发优势产区，形成产业带，降低分散经营风险",
								"全流程溯源：建立从种子/种苗到田间管理的数字化档案，实现扫码可查生产信息", "检测中心配套：在基地内设快速检测室，对农残、重金属等关键指标进行实时监测",
								"生态循环模式：推广有机肥替代化肥、病虫害绿色防控技术，减少面源污染", "产地初加工：配备预冷设施、分级包装线，延长保鲜期并提升附加值"
							]
							break;
						case 3:
							that.xmjsText = ["分区布局科学：严格划分原料处理区、加工区、成品包装区，避免交叉污染", "设备选型先进：采用自动化生产线、智能温控系统，确保产品一致性",
								"认证体系覆盖：通过HACCP、ISO22000等食品安全管理体系认证", "过程控制节点：设置关键控制点（CCP），如熬制时间、杀菌温度等参数监控",
								"新品开发机制：设立研发中心，与高校合作开发新口味、健康概念产品", "包装创新：应用锁鲜技术、环保材料，兼顾功能性与市场吸引力"
							]
							break;
						case 4:
							that.xmjsText = ["冷链全覆盖：配备低温冷库、冷藏车，确保食材全程处于规定温度环境", "智能化管理：采用WMS系统实现库存自动盘点、效期预警、批次追踪",
								"多温层运输：针对不同食材特性配置冷冻、冷藏、常温车厢", "共同配送模式：整合中小厂商需求，开展集约化配送降低成本",
								"数据平台对接：接入产业链大数据平台，实现供需匹配、路径优化", "区块链溯源：利用区块链技术记录物流环节信息，增强供应链透明度"
							]
							break;
						default:
							break;
					}
				}, 0)
			},
			changeTp(index) {
				this.tabbarChildIndex2 = index
				switch (index) {
					case 1:
						this.tpScList = {
							zcz: '78.5亿',
							qyCount: '18000家',
							list: [{
									title: '粮油',
									count: '23.55亿',
									comCount: '1500家',
									color: '#9BC74B'
								},
								{
									title: '肉蛋奶',
									count: '19.63亿',
									comCount: '2000家',
									color: '#DDFAA9'
								}, {
									title: '休闲食品',
									count: '15.70亿',
									comCount: '1800家',
									color: '#4B4DC7'
								}, {
									title: '果蔬茶',
									count: '7.85亿',
									comCount: '1600家',
									color: '#0E8AA5'
								}, {
									title: '预制菜',
									count: '6.28亿',
									comCount: '2200家',
									color: '#C47A7A'
								}, {
									title: '火锅食材',
									count: '3.93亿',
									comCount: '2400家',
									color: '#F31515'
								}, {
									title: '中药材',
									count: '1.57亿',
									comCount: '1500家',
									color: '#1791DD'
								}
							]
						}
						break;
					case 2:
						this.tpScList = {
							zcz: '513.81 亿',
							qyCount: '1662 家',
							list: [{
									"title": "肉制品",
									"count": "180.7亿",
									"comCount": "450家",
									"color": "#F44336"
								},
								{
									"title": "丸滑制品",
									"count": "120.5亿",
									"comCount": "380家",
									"color": "#E91E63"
								},
								{
									"title": "蔬菜菌菇",
									"count": "90.2亿",
									"comCount": "320家",
									"color": "#9C27B0"
								},
								{
									"title": "豆制品",
									"count": "65.3亿",
									"comCount": "280家",
									"color": "#673AB7"
								},
								{
									"title": "水产品",
									"count": "45.8亿",
									"comCount": "150家",
									"color": "#3F51B5"
								},
								// {
								// 	"title": "主食类",
								// 	"count": "38.5亿",
								// 	"comCount": "240家",
								// 	"color": "#2196F3"
								// },
								{
									"title": "调味料",
									"count": "32.8亿",
									"comCount": "180家",
									"color": "#03A9F4"
								},
								{
									"title": "其他食材",
									"count": "78.7亿",
									"comCount": "502家",
									"color": "#00BCD4"
								}
							]
						}
						break;
					case 3:
						this.tpScList = {
							zcz: '995.7 亿',
							qyCount: '11400 家',
							list: [{
									"title": "传统川渝火锅",
									"count": "450.8亿",
									"comCount": "3200家",
									"color": "#F44336"
								},
								{
									"title": "北派涮羊肉火锅",
									"count": "180.5亿",
									"comCount": "1800家",
									"color": "#E91E63"
								},
								{
									"title": "海鲜火锅",
									"count": "120.3亿",
									"comCount": "1500家",
									"color": "#9C27B0"
								},
								{
									"title": "养生火锅",
									"count": "90.2亿",
									"comCount": "1200家",
									"color": "#673AB7"
								},
								{
									"title": "快餐式火锅",
									"count": "75.6亿",
									"comCount": "2500家",
									"color": "#3F51B5"
								},
								{
									"title": "特色主题火锅",
									"count": "45.8亿",
									"comCount": "800家",
									"color": "#2196F3"
								},
								{
									"title": "跨境融合火锅",
									"count": "32.5亿",
									"comCount": "400家",
									"color": "#03A9F4"
								}
							]
						}
						break;
					default:
						break;
				}
			},
			changeCyzs(index) {
				this.tabbarChildIndex1 = index
				this.investDetail = null
			},
			// 产业招商已改接真实接口，以下旧演示文案切换逻辑保留但不再使用
			_changeCyzsLegacy(index) {
				this.zcfwText = ''
				let that = this
				setTimeout(function() {
					switch (index) {
						case 1:
							that.zcfwText = [
								"高质量发展与消费升级引导：工信部等十一部门提出到2025年形成“百亿龙头、千亿集群、万亿产业”的地方特色食品格局，重点支持地域食材供应链整合和标准化生产",
								"食品安全与标准化建设：《餐饮业促进和经营管理办法》强化食品安全监管，要求企业建立从原料到终端的全流程追溯体系",
								"重庆市火锅产业专项规划：到2027年实现全产业产值5000亿元，打造全球火锅食材生产集散中心、全国火锅标准制定发布中心",
								"四川省产业链协同政策：重点推动川味火锅底料、花椒等核心原料的标准化生产和工业化加工，鼓励供应链企业与海外资源对接",
								"冷链物流与数字化转型：政策鼓励企业采用智能仓储、物联网技术和区块链溯源系统，提升食材流通效率",
								"冷链物流政策支持：《有效降低全社会物流成本行动方案》通过补贴或税收减免支持冷链基础设施建设",
								"预制菜与工业化生产：政策支持预制菜产业园建设，推动供应链向中央厨房模式转型",
								"地域食材开发与绿色采购：多地政府联合农业部门推广地域食材的标准化种植/养殖，并通过补贴鼓励企业采购有机食材",
								"供应链服务平台建设：地方政府优先引进第三方供应链服务商，提供集采分销、仓储物流、金融支持等一体化服务",
								"特色食材深加工项目：招商项目需具备深加工能力和品牌孵化能力，推动初级农产品向高附加值成品转化",
								"数字化解决方案提供商：政策鼓励引入AI点餐系统、智能库存管理SaaS服务商，提升门店运营效率",
								"资金扶持：对符合条件的供应链项目给予贷款贴息、融资担保等金融支持", "人才引进：针对供应链管理、冷链技术等领域的人才提供落户补贴和培训资源",
								"出口激励：鼓励供应链企业开拓东南亚市场，提供出口退税和国际认证补贴"
							]
							break;
						case 2:
							that.zcfwText = [
								"打造火锅食材优质供给基地：加强农商、农企对接互联，坚持“一区（县）一品”，发展标准化、规模化、绿色化种植养殖基地，重点建设花椒、辣椒、苕粉等食材供给基地",
								"做强火锅食材加工基地：支持高标准规划建设火锅食材加工产业园区，培育引进龙头企业，推动农产品精深加工、冷链物流等产业向园区集中",
								"新品研发与推广：采取新品发布会等形式打造火锅食材“爆品”，鼓励企业创新口味和品类",
								"培育引进龙头企业：创新名企培育和招商引资方式，培育引进龙头企业、独角兽企业、总部型企业，加强上市辅导",
								"支持新兴加工企业做大做强：构建良好产业生态圈，鼓励打造集智能、绿色、文创于一体的特色火锅店，引导成长型企业深耕细分市场",
								"供应链整合与采购联盟：发挥“链主”企业作用，建立采购联盟，支持共建共享公共仓储设施，推广集约化配送模式",
								"标准化生产与质量管控：制定完善火锅食材生产加工管理服务营销等标准，构建火锅产业标准体系，推动地方标准上升为国家标准",
								"数字化转型支持：实施“千企万店数字化转型”行动，推进数字经济与实体经济深度融合，推动企业“上云”“用数”“赋智”",
								"技术创新与产学研合作：鼓励企业加大科技研发投入，加强与高校、科研机构协作，组建火锅产业发展智库团队",
								"重庆火锅产业园建设：到2027年基本建成全球火锅食材生产集散中心，吸引全国火锅食材加工企业集聚重庆",
								"跨区域合作：结合成渝地区双城经济圈建设，加强与重点火锅流派合作，共建川渝火锅产业联动发展新高地"
							]
							break;
						case 3:
							that.zcfwText = [
								"推动餐饮业高质量发展与供应链协同：商务部等9部门提出深化供给侧改革，鼓励餐饮业与其他产业融合发展，支持企业通过技术创新和管理创新优化流程",
								"重庆市火锅产业专项规划：将重庆打造为全球火锅食材生产集散中心，支持建设火锅食材加工产业园区，强调供应链整合和冷链物流提升",
								"区域消费场景创新与物流配套：多地政府通过文旅融合推动火锅消费场景升级，带动物流需求增长，配套即时配送服务",
								"冷链物流基础设施建设：政策鼓励采用智能仓储、物联网技术和区块链溯源系统，提升食材流通效率",
								"冷链物流政策支持：《有效降低全社会物流成本行动方案》通过补贴或税收减免支持冷链基础设施建设",
								"供应链协同与采购联盟：政策鼓励“链主”企业整合供应链资源，建立采购联盟，推动企业与上游农户合作建立直供体系",
								"加工园区与物流枢纽联动：地方政府优先引进第三方供应链服务商，提供一体化服务，通过政策优惠吸引头部企业落户",
								"数字化供应链解决方案：政策鼓励引入AI点餐系统、智能库存管理SaaS服务商，提升门店运营效率"
							]
							break;
						case 4:
							that.zcfwText = ["鼓励品牌化发展：推动餐饮服务品质提升，鼓励企业通过技术创新和管理创新优化经营模式，支持具备成熟运营体系的企业通过连锁模式扩大规模",
								"鼓励连锁化发展：打造“百亿龙头、千亿集群”，鼓励龙头企业带动产业链发展，为大型连锁品牌提供扩张机遇",
								"支持产业融合发展：鼓励“火锅+文旅”“火锅+新业态”等跨界融合，头部企业可通过加盟模式快速复制成功经验",
								"标准化运营体系：企业完善管理体系成为加盟模式基础，已建立成熟的加盟体系涵盖供应链管理、员工培训、数字化运营等环节",
								"区域化布局与下沉市场渗透：各地政府对特色餐饮文化的扶持为区域品牌提供宣传资源，企业通过调整产品结构和定价策略适配不同区域需求",
								"数字化赋能加盟商：采用智能点餐系统、无人配送等技术降低运营成本，并通过大数据分析指导选址和营销",
								"财政补贴与税收优惠：对新设加盟店给予租金补贴或税收减免，尤其在乡村振兴重点帮扶地区",
								"创业扶持基金：设立专项基金支持中小投资者加盟知名品牌，降低初始投资门槛", "培训与认证体系：联合行业协会推出火锅从业人员资质认证，提升服务质量标准",
								"绿色供应链激励：对采用环保包装、本地化采购的加盟门店给予奖励，响应“双碳”目标"
							]
							break;
						default:
							break;
					}
				}, 0);
			},
			changeZcfw(index) {
				this.tabbarChildIndex1 = index
				this.policyDetail = null
			},
			// 产业招商分类计数：/invest/summary 仅取 typeCounts（code 1/2/3/4）
			loadInvestSummary() {
				this.$request2('/admin-api/statistics/brain/invest/summary').then(res => {
					if (!res || res.code !== 0 || !res.data) return
					const value = res.data.value || res.data
					const counts = value && value.typeCounts
					if (!Array.isArray(counts)) return
					counts.forEach(c => {
						if (c && c.code >= 1 && c.code <= 4) {
							this.$set(this.investCounts, c.code, c.count || 0)
						}
					})
				}).catch(() => {})
			},
			// 招商列表：/invest/page 只取第1页，pageSize=100，不传 type 拉全部后前端分类
			loadInvests() {
				this.investLoading = true
				this.$request2('/admin-api/statistics/brain/invest/page', { params: { pageNo: 1, pageSize: 100 } }).then(res => {
					this.investLoading = false
					if (!res || res.code !== 0 || !res.data) return
					const value = res.data.value || res.data
					const list = value && value.list
					if (Array.isArray(list)) this.investAll = list
				}).catch(() => { this.investLoading = false })
			},
			openInvestDetail(item) {
				if (!item) return
				this.investDetail = item
				this.loadInvestDetail(item.id)
			},
			// 招商详情：列表 content 恒为 null，点开时按 id 取 /invest/get 的正文 value
			loadInvestDetail(id) {
				if (id === undefined || id === null || id === '') return
				this.investDetailLoading = true
				this.$request2('/admin-api/statistics/brain/invest/get', { params: { id } }).then(res => {
					this.investDetailLoading = false
					if (!res || res.code !== 0 || !res.data) return
					const value = res.data.value || res.data
					if (value && typeof value === 'object') {
						this.investDetail = Object.assign({}, this.investDetail, value)
					}
				}).catch(() => { this.investDetailLoading = false })
			},
			closeInvestDetail() {
				this.investDetail = null
				this.investDetailLoading = false
			},
			// 政策服务分类计数：/policy/summary 仅取 typeCounts（code 1/2/3）
			loadPolicySummary() {
				this.$request2('/admin-api/statistics/brain/policy/summary').then(res => {
					if (!res || res.code !== 0 || !res.data) return
					const value = res.data.value || res.data
					const counts = value && value.typeCounts
					if (!Array.isArray(counts)) return
					counts.forEach(c => {
						if (c && (c.code === 1 || c.code === 2 || c.code === 3)) {
							this.$set(this.policyCounts, c.code, c.count || 0)
						}
					})
				}).catch(() => {})
			},
			// 政策列表：/policy/page 只取第1页，pageSize=100，不传 type 拉全部后前端分类
			loadPolicies() {
				this.policyLoading = true
				this.$request2('/admin-api/statistics/brain/policy/page', { params: { pageNo: 1, pageSize: 100 } }).then(res => {
					this.policyLoading = false
					if (!res || res.code !== 0 || !res.data) return
					const value = res.data.value || res.data
					const list = value && value.list
					if (Array.isArray(list)) this.policyAll = list
				}).catch(() => { this.policyLoading = false })
			},
			openPolicyDetail(item) {
				if (!item) return
				this.policyDetail = item
				this.loadPolicyDetail(item.id)
			},
			// 政策详情：列表 content 恒为 null，点开时按 id 取 /policy/get 的正文 value
			loadPolicyDetail(id) {
				if (id === undefined || id === null || id === '') return
				this.policyDetailLoading = true
				this.$request2('/admin-api/statistics/brain/policy/get', { params: { id } }).then(res => {
					this.policyDetailLoading = false
					if (!res || res.code !== 0 || !res.data) return
					const value = res.data.value || res.data
					if (value && typeof value === 'object') {
						this.policyDetail = Object.assign({}, this.policyDetail, value)
					}
				}).catch(() => { this.policyDetailLoading = false })
			},
			closePolicyDetail() {
				this.policyDetail = null
				this.policyDetailLoading = false
			},
			// 产业运行五项图表数据：整页只请求一次，缓存到 cyyxScenarios
			getCyyxData() {
				if (this.cyyxScenarios) return
				this.$request2('/admin-api/statistics/brain/operation').then(res => {
					if (!res || res.code !== 0 || !res.data || !Array.isArray(res.data.scenarios)) {
						console.warn('产业运行接口数据异常，沿用前端演示数据', res && res.msg)
						return
					}
					this.cyyxScenarios = res.data.scenarios
					// 接口返回时若正停留在产业运行，刷新当前图表
					if (this.tabbarIndex1 === 1) {
						this.changeCyyx(this.tabbarChildIndex1)
					}
				}).catch(e => {
					console.warn('产业运行接口请求失败，沿用前端演示数据', e)
				})
			},
			changeCyyx(index) {
				this.tabbarChildIndex1 = index

				// 接口 scenarios 按 code 对应五个子项：output/added-value/export/import/profit
				const cyyxCodes = ['output', 'added-value', 'export', 'import', 'profit']
				const scenario = this.cyyxScenarios && this.cyyxScenarios.find(s => s.code === cyyxCodes[index - 1])
				if (scenario) {
					this.$nextTick(() => {
						if (this.$refs.leftTop) {
							this.$refs.leftTop.setInitData({
								leftTitle: scenario.leftTitle,
								leftData: scenario.leftData,
								rightTitle: scenario.rightTitle,
								rightData: scenario.rightData,
								xData: scenario.xData
							})
						}
					})
					return
				}

				switch (index) {
					case 1:
						this.$refs.leftTop.setInitData({
							leftTitle: '总产值(亿元)',
							leftData: [480, 510, 520, 530, 550, 580, 610, 630],
							rightTitle: '同比增速(%)',
							rightData: [5.0, 5.2, 5.1, 5.3, 5.5, 5.7, 5.8, 5.9],
							xData: ["2025年1月", "2025年2月", "2025年3月", "2025年4月", "2025年5月", "2025年6月", "2025年7月",
								"2025年8月"
							]
						})
						break;
					case 2:
						this.$refs.leftTop.setInitData({
							leftTitle: '增加值(亿元)',
							leftData: [28, 32, 30, 27, 26, 24, 23, 30],
							rightTitle: '同比增速(%)',
							rightData: [5.0, 5.2, 5.1, 1.1, 1.9, 0.8, 0.4, 5.3],
							xData: ["2025年1月", "2025年2月", "2025年3月", "2025年4月", "2025年5月", "2025年6月", "2025年7月",
								"2025年8月"
							]
						})
						break;
					case 3:
						this.$refs.leftTop.setInitData({
							leftTitle: '出口额(亿元)',
							leftData: [4.2, 3.9, 4.5, 5.1, 5.8, 6.3, 7.0, 7.5],
							rightTitle: '同比增速(%)',
							rightData: [8.5, 2.3, 15.4, 13.3, 13.8, 8.6, 11.1, 7.1],
							xData: ["2025年1月", "2025年2月", "2025年3月", "2025年4月", "2025年5月", "2025年6月", "2025年7月",
								"2025年8月"
							]
						})
						break;
					case 4:
						this.$refs.leftTop.setInitData({
							leftTitle: '进口额(亿元)',
							leftData: [3.5, 3.2, 3.6, 3.8, 4.0, 4.2, 4.1, 4.3],
							rightTitle: '同比增速(%)',
							rightData: [10.2, -5.1, 8.3, 12.1, 15.4, 10.5, 7.3, 5.8],
							xData: ["2025年1月", "2025年2月", "2025年3月", "2025年4月", "2025年5月", "2025年6月", "2025年7月",
								"2025年8月"
							]
						})
						break;
					case 5:
						this.$refs.leftTop.setInitData({
							leftTitle: '利润总额(亿元)',
							leftData: [9.8, 7.5, 8.2, 9.1, 10.5, 11.8, 12.3, 13.0],
							rightTitle: '同比增速(%)',
							rightData: [12.5, -3.2, 9.3, 14.1, 18.7, 12.8, 4.4, 5.7],
							xData: ["2025年1月", "2025年2月", "2025年3月", "2025年4月", "2025年5月", "2025年6月", "2025年7月",
								"2025年8月"
							]
						})
						break;
					default:
						break;
				}
			}


		}
	}
</script>

<style lang="scss" scoped>
	.modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 9999;
	}

	.exhibit-btn-row {
		gap: 10px;
	}

	.exhibit-btn {
		height: 22px;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%80%89%E6%8B%A9%E6%A1%862%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png');
		background-size: 100% 100%;
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 11px;
		color: #FFFFFF;
		text-align: center;
		line-height: 22px;
		cursor: pointer;
		padding: 0 8px;
	}

	.pdf-dialog {
		width: 82%;
		max-width: 1100px;
		height: 78vh;
		display: flex;
		flex-direction: column;
		background: rgba(6, 20, 50, 0.96);
		border: 1px solid rgba(138, 212, 255, 0.4);
		border-radius: 8px;
		overflow: hidden;
	}

	.pdf-head {
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 16px;
		border-bottom: 1px solid rgba(138, 212, 255, 0.25);
		background: rgba(0, 180, 255, 0.1);
	}

	.pdf-title {
		font-size: 15px;
		font-weight: 600;
		color: #fff;
		padding-left: 10px;
		border-left: 3px solid #8AD4FF;
	}

	.pdf-close {
		width: 26px;
		height: 26px;
		line-height: 24px;
		text-align: center;
		font-size: 18px;
		color: #8AD4FF;
		border: 1px solid rgba(138, 212, 255, 0.4);
		border-radius: 4px;
		cursor: pointer;

		&:hover {
			color: #fff;
			background: rgba(255, 77, 106, .3);
		}
	}

	.pdf-body {
		flex: 1;
		min-height: 0;
		position: relative;
		background: #fff;
	}

	.pdf-tip {
		position: absolute;
		top: 50%;
		left: 0;
		width: 100%;
		transform: translateY(-50%);
		text-align: center;
		font-size: 14px;
		color: #4a6a9a;
	}

	.pdf-frame {
		display: block;
		width: 100%;
		height: 100%;
		border: none;
		background: #fff;
	}

	.bzgf {
		height: 32vh;
	}

	.gflist {
		border-top: 1px solid rgba(255, 255, 255, 0.1);
		padding: 10px 0;

		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #8AD4FF;

		img {
			width: 22px;
			height: 22px;
		}
	}

	.gf-image {
		width: 130px;
		height: 130px;
		margin: 0 44px;
	}

	.gf-num-title-defalut {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 11px;
		color: #44C1EF;
		margin-left: 2px;

		a {
			font-size: 9px;
			margin-top: 5px;
		}
	}

	.gf-num-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 11px;
		color: #44C1EF;
		margin-left: 2px;
		background: linear-gradient(190deg, #FFFFFF 15%, #F7FF57 81%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;

		a {
			font-size: 9px;
			margin-top: 5px;
		}
	}

	.gf-images {
		width: 44px;
		height: 44px;
		margin-right: 5px;
	}

	.gf-num {
		width: 55px;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%BB%BF%E8%89%B2%E5%8F%91%E5%B1%95/%E8%A7%84%E8%8C%83%E8%83%8C%E6%99%AF%402x.png');
		background-size: 55px 36px;
		background-repeat: no-repeat;
		background-position-y: 20px;

		div {
			margin-left: 7px;
			font-family: DIN-BoldItalic, DIN-BoldItalic;
			font-weight: 900;
			font-size: 24px;
			font-style: italic;
			background: linear-gradient(180deg, #FFF600 0%, #ffffff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.gf-num-defalut {
		width: 55px;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BA%A7%E4%B8%9A/%E5%BB%BA%E8%AE%BE%E8%A7%84%E8%8C%83%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png');
		background-size: 55px 36px;
		background-repeat: no-repeat;
		background-position-y: 20px;

		div {
			margin-left: 7px;
			font-family: DIN-BoldItalic, DIN-BoldItalic;
			font-weight: 900;
			font-size: 24px;
			font-style: italic;
			background: linear-gradient(180deg, #73AEFF 0%, #ffffff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}


	.left-top {
		height: 255px;
	}
	.operation-overview { display: flex; flex-direction: column; min-height: 0; }
	.operation-overview-heading { flex: none; margin-bottom: 4px; color: #BDEAFF; font-size: 12px; line-height: 18px; font-weight: 600; }
	.operation-overview-chart { flex: 1; min-height: 0; height: 220px; }
	.operation-source { flex: none; max-height: 32px; overflow: hidden; color: #9CC1DD; font-size: 10px; line-height: 16px; }
	.operation-state { display: flex; flex: 1; flex-direction: column; align-items: center; justify-content: center; gap: 14px; color: #B5C5D4; font-size: 13px; text-align: center; }
	.operation-retry { padding: 6px 14px; border: 1px solid #38B6EB; border-radius: 4px; color: #BDEEFF; background: #0B4677; cursor: pointer; }
	.operation-details-button { border: 0; padding: 0; background: transparent; }
	.operation-retry:focus-visible, .operation-details-button:focus-visible { outline: 2px solid #72DFFF; outline-offset: 3px; }

	.kcfw-list {
		width: 180px;
		height: 30px;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%A7%91%E5%88%9B%E6%9C%8D%E5%8A%A1/%E5%88%97%E8%A1%A8%E8%83%8C%E6%99%AF%402x.png');
		background-size: 100% 100%;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 13px;
		color: #FFFFFF;
		line-height: 30px;
		text-align: center;
		margin-bottom: 10px;
	}

	.fwcx-top {
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%A7%91%E5%88%9B%E6%9C%8D%E5%8A%A1/%E9%A1%B6%E9%83%A8%E6%A1%86%E8%83%8C%E6%99%AF%402x.png');
		background-size: 100% 100%;
		width: 100%;
		height: 65px;
		background-repeat: no-repeat;
		background-position-y: 14px;
		margin-top: 15px;

		.kc-bg {
			background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%A7%91%E5%88%9B%E6%9C%8D%E5%8A%A1/%E7%A7%91%E5%88%9B%E6%9C%8D%E5%8A%A1%E9%A1%B6%E9%83%A8%E8%83%8C%E6%99%AF%402x.png');
			background-size: 100% 100%;
			width: 80px;
			height: 60px;
			cursor: pointer;
		}

		margin-bottom: 10px;

		img {
			width: 28px;
			height: 28px;
		}

		.fwcx-title {
			font-family: PingFang SC, PingFang SC;
			font-weight: 900;
			font-size: 10px;
			color: #44C1EF;
			background: linear-gradient(180deg, #ddebff 0%, #d1cdff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.rc-bg {
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E7%A4%BE%E4%BC%9A%E4%BA%BA%E6%89%8D%E8%83%8C%E6%99%AF%402x.png');
		background-size: 102% 75px;
		background-position-y: 25px;
		background-repeat: no-repeat;
		padding: 0 60px;
		padding-top: 13px;
		height: 250px;
	}

	/* 设置滚动条整体样式 */
	.bzgf-list::-webkit-scrollbar {
		width: 8px;
		/* 垂直滚动条宽度 */
		height: 8px;
		/* 水平滚动条高度 */
	}

	/* 设置滚动条轨道 */
	.bzgf-list::-webkit-scrollbar-track {
		background: rgba(202, 199, 199, 0.1);
		/* 轨道背景色 */
		border-radius: 4px;
		/* 圆角 */
	}

	/* 设置滚动条滑块 */
	.bzgf-list::-webkit-scrollbar-thumb {
		background: #5d70db;
		/* 滑块颜色 */
		border-radius: 4px;
		/* 圆角 */
	}

	/* 设置鼠标悬停在滑块上的样式 */
	.bzgf-list::-webkit-scrollbar-thumb:hover {
		background: #5166db;
		cursor: pointer;
		/* 悬停时颜色 */
	}

	.bzgf-list {
		height: 170px;
		overflow-y: auto;
	}

	/* 设置滚动条整体样式 */
	.fw-content::-webkit-scrollbar {
		width: 8px;
		/* 垂直滚动条宽度 */
		height: 8px;
		/* 水平滚动条高度 */
	}

	/* 设置滚动条轨道 */
	.fw-content::-webkit-scrollbar-track {
		background: rgba(202, 199, 199, 0.1);
		/* 轨道背景色 */
		border-radius: 4px;
		/* 圆角 */
	}

	/* 设置滚动条滑块 */
	.fw-content::-webkit-scrollbar-thumb {
		background: #5d70db;
		/* 滑块颜色 */
		border-radius: 4px;
		/* 圆角 */
	}

	/* 设置鼠标悬停在滑块上的样式 */
	.fw-content::-webkit-scrollbar-thumb:hover {
		background: #5166db;
		cursor: pointer;
		/* 悬停时颜色 */
	}

	.fw-content {
		color: #fff;
		font-size: 14px;
		height: 255px;
		overflow: auto;
		min-height: 200px;

		.list {
			padding: 10px 5px;
			border-bottom: 1px solid #b0b0b0;
		}

		.list-style {
			background: rgba(67, 110, 189, 0.1);
			border-bottom: none;
			margin-bottom: 10px;

			img {
				width: 30px !important;
				height: 30px !important;
				margin: 0 10px;
			}

			.zc-shuxian {
				width: 4px !important;
				height: 12px;
				background: #9BC74B;
			}

			.zc-num {
				font-family: DIN-BoldItalic, DIN-BoldItalic;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				margin-left: 5px;
			}
		}

		img {
			width: 22px;
			height: 22px;
		}

		.zxlist {
			td {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #FFFFFF;
				text-align: center;
				padding: 5px 0;
			}
		}

		.zxlist2 {
			td {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #FFFFFF;
				text-align: center;
				padding: 10px 0;
			}
		}
	}

	/* 政策服务/标准规范：列表项名称单行省略 */
	.fw-content .policy-name,
	.bzgf-list .policy-name {
		flex: 1;
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	/* 政策服务详情弹窗（复用能力中心内容弹窗视觉） */
	.popup-mask {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: rgba(0, 0, 0, .65);
		z-index: 9998;
	}

	.policy-popup {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: column;
		width: 900px;
		max-width: 90vw;
		max-height: 86vh;
		overflow: hidden;
		padding: 26px 28px;
		border: 1px solid #3b88e8;
		border-radius: 10px;
		background:
			linear-gradient(135deg, rgba(68, 193, 239, .14), transparent 22%) top left,
			linear-gradient(315deg, rgba(68, 193, 239, .1), transparent 22%) bottom right,
			rgba(10, 32, 78, .97);
		background-size: 100% 100%;
		box-shadow: inset 0 0 24px rgba(24, 132, 255, .18), 0 0 40px rgba(0, 14, 40, .6);
		z-index: 9999;
	}

	.policy-popup .popup-close {
		position: absolute;
		top: 10px;
		right: 16px;
		font-size: 30px;
		line-height: 1;
		cursor: pointer;
		color: #91c8ff;
		transition: color .2s;
	}

	.policy-popup .popup-close:hover {
		color: #fff;
	}

	.policy-popup-title {
		flex-shrink: 0;
		padding-right: 30px;
		color: #fff;
		font-size: 20px;
		font-weight: 600;
		line-height: 1.5;
	}

	.policy-popup-meta {
		display: flex;
		flex-wrap: wrap;
		flex-shrink: 0;
		align-items: center;
		gap: 14px;
		margin: 12px 0 18px;
		padding-bottom: 12px;
		border-bottom: 1px solid rgba(68, 193, 239, .25);
		color: #8ad4ff;
		font-size: 13px;
	}

	.policy-popup-body {
		min-height: 0;
		overflow-y: auto;
		padding-right: 8px;
	}

	.policy-popup-body p {
		margin: 0 0 12px;
		color: #c8def0;
		font-size: 15px;
		line-height: 1.95;
		text-indent: 2em;
		word-break: break-all;
		white-space: pre-line;
	}

	.policy-popup-body .policy-empty {
		color: #8ad4ff;
		text-indent: 0;
	}

	.policy-rich {
		color: #c8def0;
		font-size: 15px;
		line-height: 1.9;
	}

	.policy-rich ::v-deep p {
		margin: 0 0 12px;
		text-indent: 2em;
	}

	.policy-rich ::v-deep img {
		max-width: 100%;
		height: auto;
	}

	.policy-detail-loading {
		color: #8ad4ff;
		font-size: 15px;
		padding: 10px 0;
	}

	.policy-summary {
		color: #8ad4ff;
		font-size: 15px;
		line-height: 1.8;
		text-indent: 0;
	}

	.invest-field {
		color: #c8def0;
		font-size: 15px;
		line-height: 1.9;
		margin: 0 0 12px;
		word-break: break-all;
	}

	.invest-field b {
		color: #73dcff;
		font-weight: 600;
	}

	.policy-popup-footer {
		flex-shrink: 0;
		margin-top: 16px;
		padding-top: 12px;
		border-top: 1px solid rgba(68, 193, 239, .25);
		text-align: right;
	}

	.policy-source-link {
		color: #73dcff;
		font-size: 15px;
		text-decoration: underline;
		text-underline-offset: 3px;
	}

	.policy-source-link:hover {
		color: #fff;
	}

	.szhzxhei {
		height: 237px !important;
		margin-bottom: 10px;
	}

	.minHeight {
		max-height: 400px !important;
		height: 270px !important;
	}

	.top-count-title {
		font-family: JiangChengXieHei, JiangChengXieHei;
		font-size: 12px;
		font-style: normal !important;
		color: #D8F1FF;
		text-shadow: 2px 2px 4px rgba(17, 20, 22, 0.22), 0px 0px 10px rgba(73, 223, 255, 0.48);
		// background: linear-gradient(3.8059132373276543deg, #fff 0%, #b0fcff 85%);
		// -webkit-background-clip: text;
		// -webkit-text-fill-color: transparent;
		width: 100px;
	}

	.top-count-num {
		font-family: JiangChengXieHei, JiangChengXieHei;
		font-weight: 700;
		font-size: 26px;
		// color: #FFC713;
		color: #fff;

		// font-style: italic;
		a {
			font-size: 15px;
			margin-top: 8px;
			margin-left: 3px;
		}

		// background: linear-gradient(3.8059132373276543deg, #389DFF 0%, #FFFFFF 85%);

		// -webkit-background-clip: text;
		// -webkit-text-fill-color: transparent;

	}

	.top-count2 {
		position: fixed;
		top: 16%;
		left: 0;
		width: 100%;
		z-index: 7;
	}

	.top-count {
		position: fixed;
		top: 9%;
		left: 0;
		width: 100%;
		z-index: 7;
	}

	.cxfz {
		width: 220px;
		height: 233px;
		position: relative;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BA%A7%E4%B8%9A/%E5%88%9B%E6%96%B0%E5%8F%91%E5%B1%95%402x.png');
		background-size: 150px 125px;
		background-repeat: no-repeat;
		background-position-x: 20px;
		background-position-y: 30px;

		.sjzzy {
			position: absolute;
			right: 32%;
			bottom: 0;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 11px;
			color: #FFFFFF;
			text-align: center;

			.num {
				width: 80px;
				height: 80px;
				background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BC%81%E4%B8%9A%E4%BE%A7/%E4%B8%BB%E4%BD%93%E5%9F%B9%E8%82%B2/%E5%88%9B%E6%96%B0%E5%8F%91%E5%B1%95%E8%83%8C%E6%99%AF3%402x.png');
				background-size: 100% 100%;


				font-family: DIN, DIN;
				font-weight: bold;
				font-size: 16px;
				color: #FCFF34;
			}
		}

		.gyhxxh {
			position: absolute;
			right: 0;
			top: 0;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 11px;
			color: #FFFFFF;
			text-align: center;

			.num {
				width: 80px;
				height: 80px;
				background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BC%81%E4%B8%9A%E4%BE%A7/%E4%B8%BB%E4%BD%93%E5%9F%B9%E8%82%B2/%E5%88%9B%E6%96%B0%E5%8F%91%E5%B1%95%E8%83%8C%E6%99%AF2%402x.png');
				background-size: 100% 100%;


				font-family: DIN, DIN;
				font-weight: bold;
				font-size: 16px;
				color: #EDFFF3;
			}
		}

		.sjqy {
			position: absolute;
			left: 0;
			top: 0;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 11px;
			color: #FFFFFF;
			text-align: center;

			.num {
				width: 80px;
				height: 80px;
				background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BC%81%E4%B8%9A%E4%BE%A7/%E4%B8%BB%E4%BD%93%E5%9F%B9%E8%82%B2/%E5%88%9B%E6%96%B0%E5%8F%91%E5%B1%95%E8%83%8C%E6%99%AF1%402x.png');
				background-size: 100% 100%;


				font-family: DIN, DIN;
				font-weight: bold;
				font-size: 16px;
				color: #8AD4FF;
			}

		}
	}

	.td-info {
		width: 177px;
		height: 233px;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BA%A7%E4%B8%9A/%E6%A2%AF%E5%BA%A6%E5%9F%B9%E8%82%B2%402x.png');
		background-size: 100% 100%;
		margin: 10px 0;

		.text5 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 14px;
			color: #FFFFFF;
			background: linear-gradient(180deg, #FF9393 15%, #FF0000 81%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			margin-bottom: 18px;
		}

		.text4 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 14px;
			color: #FEFBF6;
			background: linear-gradient(180deg, #FFFFFF 15%, #5F57FF 81%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}

		.text3 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 14px;
			background: linear-gradient(180deg, #FFFFFF 15%, #F7FF57 81%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}

		.text2 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 14px;
			color: #F6F9FE;
			background: linear-gradient(180deg, #FFFFFF 15%, #F7FF57 81%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}

		.text1 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 14px;
			color: #FEFDF6;
			margin-top: 20px;
		}
	}

	.td {
		position: relative;
		margin-top: 5px;

		.tdpy {
			font-weight: normal;
			font-size: 12px;
			color: #E6EDF8;
			margin-top: -8px;
			position: absolute;
			left: 10px;
			font-style: italic;
		}

		.tdbg {
			width: 158px;
			height: 18px;
			background: linear-gradient(90deg, #3A61BB 0%, #29439D 100%);
			border-radius: 0px 0px 0px 0px;
		}
	}

	.info-style {
		width: 380px;
		height: 390px;
		background: rgba(10, 125, 190, 0.25);
		border-radius: 12px 12px 12px 12px;
		padding: 7px 20px;

		.xq {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 11px;
			color: #0AA7FF;
			cursor: pointer;
		}

		.data-time {
			font-weight: 400;
			font-size: 11px;
			color: #B5C5D4;
		}

		.rc-news {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #F0996E;
			margin-bottom: 5px;

			.yuan {
				width: 6px;
				height: 6px;
				background: #F0996E;
				border-radius: 50%;
				margin-right: 5px;
			}
		}

		.rc-title {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #B3C8D4;
		}

		.rc-num {
			font-family: DINPro, DINPro;
			font-weight: 500;
			font-size: 20px;
			color: #65EAFF;
		}

		.tp-list {
			width: 270px;
			height: 38px;
			border-radius: 0px 0px 0px 0px;
			border: 1px solid rgba(28, 41, 66, 0.1);

			.tp-color {
				width: 12px;
				height: 5px;
				background: #9BC74B;
				border-radius: 0px 0px 0px 0px;
				margin: 0 10px;
			}

			.tp-list-title {
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 14px;
				color: #FFFFFF;
				width: 45%;
			}

			.tp-list-count {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #8AD4FF;
			}

			.tp-list-jiantou {
				width: 30px;
				height: 20px;
			}
		}

		.tp-left {
			background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E4%BA%A7%E4%B8%9A/%E5%9B%BE%E8%B0%B1%E5%B7%A6%E8%83%8C%E6%99%AF%402x.png');
			background-size: 75px 82px;
			height: 82px;
			background-repeat: no-repeat;

			.tp-zcz {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #CAD6F1;
				margin-left: 35px;
			}

			.tp-zcz-num {
				font-family: DIN, DIN;
				font-weight: bold;
				font-size: 20px;
				color: #E1B46D;
				font-style: normal;
				text-transform: none;
				background: linear-gradient(180deg, #FFFFFF 0%, #E1B46D 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				margin-left: 12px;
			}

			.tp-zcz-num2 {
				font-family: DIN, DIN;
				font-weight: bold;
				font-size: 20px;
				color: #E1B46D;
				font-style: normal;
				text-transform: none;
				background: linear-gradient(180deg, #FFFFFF 0%, #6BB3F0 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				margin-left: 16px;
			}
		}

		.check2 {
			height: 30px;
			background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%80%89%E6%8B%A9%E6%A1%862%E9%80%89%E4%B8%AD%402x.png');
			background-size: 100% 100%;

			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 11px;
			color: #FFFFFF;
			text-align: center;
			line-height: 30px;
			padding: 0 8px;
			cursor: pointer;

			a {
				font-size: 9px;
				margin-top: 2px;
			}
		}

		.check2-defalut {
			height: 30px;
			background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%80%89%E6%8B%A9%E6%A1%862%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png');
			background-size: 100% 100%;

			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 11px;
			color: #FFFFFF;
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			padding: 0 8px;

			a {
				font-size: 9px;
				margin-top: 2px;
			}
		}

		.check3 {
			height: 22px;
			background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%80%89%E6%8B%A9%E6%A1%862%E9%80%89%E4%B8%AD%402x.png');
			background-size: 100% 100%;

			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 11px;
			color: #FFFFFF;
			text-align: center;
			line-height: 22px;
			padding: 0 8px;
		}

		.check3-defalut {
			height: 22px;
			background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%80%89%E6%8B%A9%E6%A1%862%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png');
			background-size: 100% 100%;

			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 11px;
			color: #FFFFFF;
			text-align: center;
			line-height: 22px;
			cursor: pointer;
			padding: 0 8px;
		}

		.check {
			width: 70px;
			height: 70px;
			border-radius: 12px 12px 12px 12px;
			background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E7%82%B9%E5%87%BB%402x.png');
			background-size: 100% 100%;

			img {
				width: 44px;
				height: 25px;
				margin-bottom: 5px;
			}

			font-weight: 600;
			font-size: 12px;
			color: #FFFFFF;
			text-align: center;
		}

		.tabbar-defalut {
			width: 70px;
			height: 70px;
			border-radius: 12px 12px 12px 12px;
			background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%A4%A7%E6%A0%87%E9%A2%98/%E6%9C%AA%E7%82%B9%E5%87%BB%402x.png');
			background-size: 100% 100%;
			cursor: pointer;

			img {
				width: 44px;
				height: 25px;
				margin-bottom: 5px;
			}

			font-weight: 600;
			font-size: 12px;
			color: #FFFFFF;
			text-align: center;
		}
	}

	.title {
		width: 20.8vw;
		height: 4vh;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%A0%87%E9%A2%98%402x.png');
		background-size: 100% 100%;

		div {
			font-family: JiangChengXieHei, JiangChengXieHei;
			font-size: 24px;
			font-weight: 900;
			color: #F6F9FE;
			text-align: left;
			font-style: italic;
			text-transform: none;
			background: linear-gradient(180deg, #FFFFFF 15%, #F7FF57 81%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			margin-left: 50px;
			margin-top: -10px;
		}
	}

	.left {
		position: fixed;
		left: 20px;
		top: 8vh;
		z-index: 8;
	}

	.right {
		position: fixed;
		right: 20px;
		top: 8vh;
		z-index: 999;
	}

	.centerbg {
		width: 1200px;
		height: 900px;
		position: relative;
		/* background-image: url('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/bg%E5%8A%A8%E7%94%BB.png');
		background-size: 100% 100%; */
	}
</style>

<style lang="scss" scoped>
	.trtdstyle {
		display: flex;
	
		>td,
		>th {
			&:nth-child(1) {
				flex: 1;
			}
	
			&:nth-child(2) {
				flex: 1.1;
			}
	
			&:nth-child(6) {
				flex: 1.8;
			}
	
			&:nth-child(4) {
				flex: 0.5;
			}
	
			&:nth-child(3) {
				flex: 1.5;
			}
	
	
	
			&:nth-child(5) {
				flex: 0.5;
			}
		}
	}

	.trade-dialog-switch {
		position: absolute;
		top: 12px;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		gap: 12px;
		z-index: 2;
	}

	.trade-dialog-switch__item {
		min-width: 138px;
		height: 40px;
		padding: 0 20px;
		border: 1px solid rgba(74, 196, 255, 0.7);
		border-radius: 20px;
		background: rgba(5, 35, 85, 0.78);
		box-shadow: inset 0 0 20px rgba(24, 132, 255, 0.22);
		color: #c5ebff;
		font-size: 18px;
		font-weight: bold;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
		transition: all 0.2s ease;
	}

	.trade-dialog-switch__item:hover {
		color: #ffffff;
		border-color: #78ddff;
	}

	.trade-dialog-switch__item--active {
		background: linear-gradient(90deg, rgba(0, 136, 255, 0.95), rgba(0, 211, 255, 0.95));
		border-color: transparent;
		box-shadow: 0 8px 20px rgba(0, 153, 255, 0.28);
		color: #ffffff;
	}

	.trade-chart-wrap {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 36px;
		box-sizing: border-box;
	}

	.mySeamlessScrollStyle {
		padding: 80px;
		background: url('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/standardizedAquaculture/popup/bg%402x.png') center center / 100% 100% no-repeat;
		background-color: transparent;
		position: relative;
		opacity: 0.9;
		font-size: 17px;
		height: 60vh;
		
		//滚动容器大小
		.scrollStyle {
			width: 100%;
			height: 100%;
			overflow: hidden; //必须
		}

		//h5表格样式
		.customTable {
			width: 100%;
			table {
				width: 80%;
				margin: 20px 0;
				border-collapse: collapse;
				box-shadow: 0 2px 20px rgba(0, 150, 255, 0.3);
				background-color: rgba(0, 43, 161, 0.3);
				// border: 1px solid #0096ff;
			}

			th,
			td {
				padding: 20px;
				text-align: center;
				// border: 1px solid #0096ff;
			}

			th {
				background-color: #0096ff;
				color: #dfdfdf;
				text-transform: uppercase;
			}

			tr {
				color: #dfdfdf;
			}

			tr:nth-child(even) {
				background-color: rgba(17, 34, 64, 0.2);
			}

			tr:hover {
				background-color: #0096ff;
				color: #FFFFFF;
			}

			thead {
				border-bottom: 2px solid #0096ff;
			}
		}

	}
</style>
